var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInteractiondesignAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-37"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-37",
    cx: 250,
    cy: 363.27,
    rx: 230.41,
    ry: 128.21,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-37",
    points: "38.77 369.25 160.63 439.61 384.04 310.62 262.18 240.26 38.77 369.25",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-37",
    cx: 342.72,
    cy: 412.97,
    rx: 83.16,
    ry: 48.02,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-37",
    cx: 268.72,
    cy: 387.09,
    rx: 62.06,
    ry: 35.83,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.63,335.31A70,70,0,0,0,55,314.85C51.84,304.14,44.88,293,35.84,290.06S22.27,293,23.6,299.28c1.14,5.43,7.56,10.49,12.3,15.6s13.35,17.19,15,28.17l5.15,1.1Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.63,335.31A70,70,0,0,0,55,314.85C51.84,304.14,44.88,293,35.84,290.06S22.27,293,23.6,299.28c1.14,5.43,7.56,10.49,12.3,15.6s13.35,17.19,15,28.17l5.15,1.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M53.59,339.77a.58.58,0,0,1-.53-.62c1.77-27-23-44.74-23.29-44.92a.58.58,0,1,1,.67-1c.26.18,25.59,18.28,23.79,46a.58.58,0,0,1-.62.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.56,370.18a11.35,11.35,0,0,1-7.65,0,14.62,14.62,0,0,1-5.19-3.24,18.16,18.16,0,0,1-3.45-5.09,19.06,19.06,0,0,0-2.11-3.57c-1.83-2.19-5.16-2.48-7.74-3.32a10.09,10.09,0,0,1-6.91-7.34c-.65-3.46.17-7.53,3.52-9.38l-2.49-2a17.69,17.69,0,0,1-3.15-3,5.94,5.94,0,0,1-1.33-4,5.66,5.66,0,0,1,4-4.52,12,12,0,0,1,6.31,0,28,28,0,0,1,6.09,2.1,4.39,4.39,0,0,0,1.7.57,4.58,4.58,0,0,0,2.23-.76c4.87-2.55,12.28-1.57,14.16,4.36.27.87.39,1.79.69,2.65,1.11,3.21,5.2,2.69,7.63,4.38,1.58,1.11,1.08,4.15,1.21,6.07.22,3.38.29,5.76-.73,8.93-.38,1.19-1.09,2.23-1.46,3.4-.51,1.64-.35,3.61-.58,5.32-.39,2.93-1,6.58-3.87,8A7.61,7.61,0,0,1,51.56,370.18Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.86,363.61a42.23,42.23,0,0,0-9.23-17.52.49.49,0,0,0-.23-.26,53.77,53.77,0,0,0-4-4.19,22.69,22.69,0,0,1,2.72-11.74.47.47,0,0,0-.16-.64.46.46,0,0,0-.65.16,23.43,23.43,0,0,0-2.88,11.32,72.3,72.3,0,0,0-19.49-12.37.47.47,0,1,0-.34.88,70,70,0,0,1,23,15.91c-6.58-1.85-14.92.58-15.3.69a.47.47,0,0,0,.09.92.37.37,0,0,0,.18,0c.1,0,9.88-2.87,16.32-.14A41.28,41.28,0,0,1,54,363.83a.46.46,0,0,0,.4.36.42.42,0,0,0,.16,0A.47.47,0,0,0,54.86,363.61Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--drafting-table--inject-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "349.23 220.29 349.23 313.5 352.71 311.48 352.71 218.28 349.23 220.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.23 313.5 345.74 311.48 345.74 218.28 349.23 220.29 349.23 313.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.81 328.76 52.87 271.05 52.87 276.82 152.81 334.53 352.71 219.16 352.65 213.5 152.81 328.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.65 213.5 352.71 219.16 152.81 334.53 152.81 328.76 352.65 213.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.76,155.68,52.87,271.05l99.94,57.71L352.65,213.5ZM152.81,323,62.86,271.05l189.9-109.59,89.95,51.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.86 271.06 252.76 161.46 342.71 213.39 337.71 216.28 252.76 167.22 67.86 273.94 62.86 271.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.85 279.71 82.85 201.81 77.85 198.92 72.85 276.82 77.85 279.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.65 207.73 272.75 80.67 72.91 195.93 72.91 201.7 152.81 328.76 352.65 213.5 352.65 207.73",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.65 207.73 272.75 80.67 72.91 195.93 72.91 201.7 152.81 328.76 352.65 213.5 352.65 207.73",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.81 322.99 152.81 328.76 352.65 213.5 352.65 207.73 152.81 322.99",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.81 322.99 72.91 195.93 272.75 80.67 352.65 207.73 152.81 322.99",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.81 322.99 72.91 195.93 272.75 80.67 352.65 207.73 152.81 322.99",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.81 333.65 152.81 426.86 156.3 424.85 156.3 331.64 152.81 333.65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.81 426.86 149.33 424.85 149.33 331.64 152.81 333.65 152.81 426.86",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.35 277.94 56.35 371.14 59.83 369.13 59.83 275.93 56.35 277.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.35 371.14 52.87 369.13 52.87 275.93 56.35 277.94 56.35 371.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.26 202.75 267.77 99.79 334.56 206.01 156.06 308.96 89.26 202.75",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.13 200.2 268.64 97.24 335.43 203.46 156.93 306.41 90.13 200.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.05,242.87l-2.64-3.78a.67.67,0,0,0-.85-.19l-.23.13a.53.53,0,0,0-.17.78l2.65,3.78a.65.65,0,0,0,.85.19l.22-.13A.53.53,0,0,0,135.05,242.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.73,241.33l-2.65-3.78a.66.66,0,0,0-.85-.19l-.23.13a.53.53,0,0,0-.17.78l2.65,3.78a.66.66,0,0,0,.85.19l.22-.13A.53.53,0,0,0,137.73,241.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.32,244.33l2.25-.05a.23.23,0,0,0,.18-.36l-1.25-1.78a.22.22,0,0,0-.38,0l-1,1.83A.23.23,0,0,0,128.32,244.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.93,245.25l-1.49-2.13A.37.37,0,0,0,127,243l-.13.07a.3.3,0,0,0-.09.44l1.49,2.13a.36.36,0,0,0,.48.11l.13-.07A.29.29,0,0,0,128.93,245.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.77,237.15l-1,1.83a.23.23,0,0,1-.38,0l-1.25-1.79a.23.23,0,0,1,.18-.36l2.25,0A.22.22,0,0,1,140.77,237.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.44,238,140,235.89a.31.31,0,0,1,.1-.44l.13-.07a.38.38,0,0,1,.48.11l1.49,2.13a.3.3,0,0,1-.1.44l-.13.07A.36.36,0,0,1,141.44,238Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.92,255a.38.38,0,0,1-.36-.26,4.25,4.25,0,0,1,.86-3.18,7,7,0,0,1,5.37-2.91.38.38,0,0,1,.4.34.37.37,0,0,1-.34.39A6.25,6.25,0,0,0,139,252a3.61,3.61,0,0,0-.76,2.55.36.36,0,0,1-.25.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.33,248.52l-2.44-.9a.26.26,0,0,0-.35.29l.46,2.38a.25.25,0,0,0,.4.16l2-1.47A.27.27,0,0,0,146.33,248.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.34,257.15a.38.38,0,0,1-.37-.34.37.37,0,0,1,.34-.4,6.25,6.25,0,0,0,4.82-2.6,3.6,3.6,0,0,0,.76-2.55.37.37,0,0,1,.25-.46.38.38,0,0,1,.46.25,4.25,4.25,0,0,1-.86,3.18,7,7,0,0,1-5.37,2.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.83,257.29l2.44.91a.27.27,0,0,0,.35-.3l-.46-2.38a.26.26,0,0,0-.41-.16l-2,1.48A.26.26,0,0,0,139.83,257.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.65,271.8a.36.36,0,0,1-.29-.16.34.34,0,0,1,.13-.46c1.24-.72,2-2.28,2.38-4.77.23-1.63.88-3.78,2.61-4.78a.33.33,0,0,1,.33.58c-1.5.87-2.07,2.81-2.28,4.3-.39,2.7-1.28,4.42-2.71,5.25A.33.33,0,0,1,148.65,271.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.68,261l-1,1.91a.24.24,0,0,1-.4,0l-1.3-1.86a.23.23,0,0,1,.19-.36l2.34-.05A.23.23,0,0,1,155.68,261Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27,267.28a11.55,11.55,0,0,1-3.16-.5c-2.63-.76-4.58-.78-5.82-.07a.33.33,0,1,1-.34-.57c1.42-.82,3.5-.82,6.34,0,1.3.37,3.71.86,5.3-.06a.34.34,0,1,1,.34.58A5.35,5.35,0,0,1,154.27,267.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55,265.08l-2.34.05a.23.23,0,0,0-.19.36l1.3,1.86a.24.24,0,0,0,.4,0l1-1.91A.23.23,0,0,0,158.55,265.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.14,277l-5.72,3.3a.61.61,0,0,1-.81-.18l-.08-.1a.51.51,0,0,1,.17-.75l5.72-3.3a.61.61,0,0,1,.81.18l.07.1A.51.51,0,0,1,165.14,277Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.47,278.93l-5.73,3.31a.64.64,0,0,1-.81-.18l-.07-.11a.5.5,0,0,1,.16-.74l5.73-3.31a.64.64,0,0,1,.81.18l.07.11A.5.5,0,0,1,166.47,278.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.79,280.83l-5.72,3.3a.61.61,0,0,1-.81-.18l-.07-.1a.51.51,0,0,1,.16-.75l5.72-3.3a.63.63,0,0,1,.82.18l.07.1A.51.51,0,0,1,167.79,280.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.47,280.74a.38.38,0,0,1-.31-.18.36.36,0,0,1,.13-.49l3.56-2.05a.36.36,0,0,1,.36.62l-3.56,2.05A.41.41,0,0,1,154.47,280.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,281.4a.35.35,0,0,1-.29-.15l-2.37-3.38a.36.36,0,0,1,.59-.41l2.36,3.38a.36.36,0,0,1-.08.5A.42.42,0,0,1,157.43,281.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.21,238a1.2,1.2,0,0,1-1-.48l-31.4-44.84a1,1,0,0,1-.16-.8,1.24,1.24,0,0,1,.6-.79L212.46,176a1.27,1.27,0,0,1,1.69.29l31.56,45.06a.71.71,0,0,1,.13.59,1.39,1.39,0,0,1-.73.78l-26.2,15.12A1.37,1.37,0,0,1,218.21,238Zm-5-61.63a.83.83,0,0,0-.42.11l-26.19,15.12a.64.64,0,0,0-.32.41.38.38,0,0,0,.06.33l31.4,44.84a.71.71,0,0,0,.92.12l26.2-15.12c.37-.22.44-.35.45-.4a.16.16,0,0,0,0-.12L213.67,176.6A.58.58,0,0,0,213.17,176.38Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.78,192.65a.49.49,0,0,1-.16.72.6.6,0,0,1-.78-.18.48.48,0,0,1,.16-.71A.61.61,0,0,1,189.78,192.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.45,191.69a.48.48,0,0,1-.16.71.61.61,0,0,1-.78-.17.49.49,0,0,1,.16-.72A.6.6,0,0,1,191.45,191.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.13,190.72a.49.49,0,0,1-.16.72.6.6,0,0,1-.78-.18.48.48,0,0,1,.15-.71A.61.61,0,0,1,193.13,190.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,179.65h0l-2-.45a.15.15,0,0,1,.07-.29l2,.45a.16.16,0,0,1,.12.18A.15.15,0,0,1,214,179.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.73,180.36h0a.13.13,0,0,1-.11-.17l.41-1.86a.14.14,0,0,1,.17-.11.15.15,0,0,1,.12.17l-.41,1.86A.16.16,0,0,1,212.73,180.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.6,197.07l10.37-6a.54.54,0,0,0,.17-.78l-.15-.22a.67.67,0,0,0-.85-.19l-10.37,6a.53.53,0,0,0-.17.78l.15.21A.65.65,0,0,0,201.6,197.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.59,198.42l8.87-5.12a.21.21,0,0,0,.07-.3l-.06-.09a.25.25,0,0,0-.33-.07L203.27,198a.21.21,0,0,0-.07.3l.06.09A.25.25,0,0,0,203.59,198.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.72,203.63a7,7,0,0,1-3,9,8.7,8.7,0,0,1-9.22-.48l1.07-7.26,8.4,2.83c.65.21.74.06.21-.35L218.07,206l.86-3.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.68,199.75a7,7,0,0,0-2.27,10.33,7.73,7.73,0,0,0,1,1.15l1.1-7.38a.32.32,0,0,1,.17-.26h0a.4.4,0,0,1,.34,0l5.9,2,1-3.82a.4.4,0,0,1,.49-.25l3.58.84,0-.06A8.71,8.71,0,0,0,210.68,199.75Zm4.54,2.18a1.19,1.19,0,0,1-1.53-.34,1,1,0,0,1,.31-1.41,1.18,1.18,0,0,1,1.53.35A1,1,0,0,1,215.22,201.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.13,220.39l-2.64-3.78a.67.67,0,0,0-.85-.19l-.23.14a.52.52,0,0,0-.17.77l2.65,3.78a.64.64,0,0,0,.85.19l.22-.13A.52.52,0,0,0,224.13,220.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.81,218.85l-2.65-3.78a.66.66,0,0,0-.85-.19l-.23.13a.54.54,0,0,0-.17.78l2.65,3.78a.66.66,0,0,0,.85.19l.23-.13A.54.54,0,0,0,226.81,218.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.4,221.85l2.25,0a.23.23,0,0,0,.18-.36l-1.25-1.78a.22.22,0,0,0-.38,0l-1,1.83A.23.23,0,0,0,217.4,221.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,222.77l-1.49-2.13a.37.37,0,0,0-.48-.11l-.12.08a.29.29,0,0,0-.1.43l1.49,2.14a.37.37,0,0,0,.48.1l.13-.07A.29.29,0,0,0,218,222.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,214.67l-1,1.83a.23.23,0,0,1-.38,0l-1.25-1.79a.22.22,0,0,1,.18-.35l2.25,0A.22.22,0,0,1,229.85,214.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.52,215.55,229,213.42a.3.3,0,0,1,.1-.44l.13-.08a.38.38,0,0,1,.48.11l1.49,2.13a.3.3,0,0,1-.1.44l-.13.07A.38.38,0,0,1,230.52,215.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.12,231.69a.13.13,0,0,1-.14-.1,1.65,1.65,0,0,1,.34-1.27,2.76,2.76,0,0,1,2.14-1.16.14.14,0,0,1,.16.13.15.15,0,0,1-.14.16,2.48,2.48,0,0,0-1.92,1,1.42,1.42,0,0,0-.3,1,.16.16,0,0,1-.1.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.47,229.1l-1-.36a.1.1,0,0,0-.14.11l.18,1a.11.11,0,0,0,.17.07l.79-.59A.1.1,0,0,0,221.47,229.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.88,232.54a.14.14,0,0,1-.14-.14.13.13,0,0,1,.13-.15,2.48,2.48,0,0,0,1.92-1,1.41,1.41,0,0,0,.31-1,.14.14,0,0,1,.1-.18.14.14,0,0,1,.18.1,1.68,1.68,0,0,1-.34,1.26,2.76,2.76,0,0,1-2.14,1.17Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.88,232.6l1,.36a.1.1,0,0,0,.13-.12l-.18-1a.1.1,0,0,0-.16-.06l-.79.59A.1.1,0,0,0,218.88,232.6Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.42,228.38a.16.16,0,0,1-.13-.08.15.15,0,0,1,.06-.2,2.68,2.68,0,0,0,1.05-2.1,2.83,2.83,0,0,1,1.15-2.11.15.15,0,1,1,.15.25,2.55,2.55,0,0,0-1,1.9,3.17,3.17,0,0,1-1.2,2.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.52,223.62l-.46.84a.1.1,0,0,1-.17,0l-.58-.82a.1.1,0,0,1,.09-.16l1,0A.11.11,0,0,1,230.52,223.62Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.9,226.38a5.13,5.13,0,0,1-1.4-.22,3.42,3.42,0,0,0-2.56,0,.16.16,0,0,1-.21,0,.16.16,0,0,1,.06-.21,3.63,3.63,0,0,1,2.8,0,3.31,3.31,0,0,0,2.34,0,.15.15,0,0,1,.2.05.16.16,0,0,1-.06.21A2.3,2.3,0,0,1,229.9,226.38Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.79,225.41l-1,0a.1.1,0,0,0-.09.16l.58.82a.1.1,0,0,0,.17,0l.46-.84A.1.1,0,0,0,231.79,225.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4,219.72,237,221.08a.25.25,0,0,1-.33-.07l0,0a.22.22,0,0,1,.07-.31l2.35-1.36a.28.28,0,0,1,.34.07l0,0A.21.21,0,0,1,239.4,219.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.94,220.5l-2.35,1.36a.27.27,0,0,1-.34-.07l0,0a.21.21,0,0,1,.06-.31l2.36-1.36a.26.26,0,0,1,.33.07l0,0A.19.19,0,0,1,239.94,220.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.49,221.28l-2.35,1.36a.26.26,0,0,1-.34-.07l0,0a.22.22,0,0,1,.07-.31l2.35-1.36a.27.27,0,0,1,.34.07l0,0A.21.21,0,0,1,240.49,221.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,221.25a.16.16,0,0,1-.13-.08.15.15,0,0,1,.05-.2l1.47-.84a.15.15,0,0,1,.2.05.14.14,0,0,1-.06.2l-1.46.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.23,221.52a.16.16,0,0,1-.13-.06l-1-1.39a.15.15,0,0,1,0-.21.14.14,0,0,1,.2,0l1,1.39a.15.15,0,0,1,0,.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.2,206.91a.89.89,0,0,1-.16-.66h0a.85.85,0,0,1,.44-.64,1.22,1.22,0,0,1,1.27.19s.11,0,.1,0a1,1,0,0,1,.32-1.17,1.08,1.08,0,0,1,.82-.11h0a1.05,1.05,0,0,1,.59.41c.45.63.08,1.35-.14,2.07l-.29.72-.81-.07C226.53,207.54,225.65,207.55,225.2,206.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,155.59a2.43,2.43,0,0,1-.43-1.72h0a2.34,2.34,0,0,1,1.15-1.66,3.19,3.19,0,0,1,3.3.51c.1.07.29,0,.26,0a2.57,2.57,0,0,1,.82-3,2.81,2.81,0,0,1,2.14-.26h0a2.78,2.78,0,0,1,1.54,1.07c1.18,1.65.21,3.51-.37,5.39l-.75,1.85-2.1-.18C287.78,157.21,285.52,157.24,284.34,155.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--mobile--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.79,220.05a1.19,1.19,0,0,1-1-.48L237.4,174.72a1,1,0,0,1-.15-.79,1.24,1.24,0,0,1,.6-.79L264.05,158a1.29,1.29,0,0,1,1.69.29l31.56,45.07a.75.75,0,0,1,.13.59,1.35,1.35,0,0,1-.73.77l-26.2,15.13A1.4,1.4,0,0,1,269.79,220.05Zm-5-61.64a.91.91,0,0,0-.42.11l-26.2,15.13a.71.71,0,0,0-.32.41.44.44,0,0,0,.07.33l31.4,44.84a.72.72,0,0,0,.92.12l26.19-15.13c.38-.21.45-.35.46-.39s0-.05-.05-.12l-31.55-45.07A.61.61,0,0,0,264.76,158.41Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M265.54,161.69h0l-2-.46a.13.13,0,0,1-.11-.17.14.14,0,0,1,.17-.11l2,.45a.15.15,0,0,1,.11.18A.14.14,0,0,1,265.54,161.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.32,162.39h0a.15.15,0,0,1-.11-.18l.41-1.85a.14.14,0,0,1,.17-.12.15.15,0,0,1,.11.18l-.4,1.86A.15.15,0,0,1,264.32,162.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.79,178.94l10.37-6a.53.53,0,0,0,.17-.78l-.15-.22a.66.66,0,0,0-.85-.19l-10.37,6a.54.54,0,0,0-.17.78l.15.21A.66.66,0,0,0,245.79,178.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.34,184l10.37-6a.54.54,0,0,0,.17-.78l-.15-.22a.67.67,0,0,0-.85-.19l-10.37,6a.53.53,0,0,0-.17.78l.15.21A.65.65,0,0,0,249.34,184Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.44,173l1.52-.88a.54.54,0,0,0,.18-.78l-.16-.22a.65.65,0,0,0-.85-.19l-1.52.88a.54.54,0,0,0-.18.78l.16.22A.65.65,0,0,0,268.44,173Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24,185.91l8.87-5.12a.21.21,0,0,0,.07-.3l-.06-.09a.26.26,0,0,0-.34-.07l-8.87,5.12a.21.21,0,0,0-.06.31l.06.08A.25.25,0,0,0,250.24,185.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.38,189.78l10.37-6a.53.53,0,0,0,.17-.78l-.15-.22a.66.66,0,0,0-.85-.19l-10.37,6a.54.54,0,0,0-.17.78l.15.21A.66.66,0,0,0,253.38,189.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.48,178.76l1.53-.89a.53.53,0,0,0,.17-.78l-.15-.21a.66.66,0,0,0-.85-.19l-1.53.88a.53.53,0,0,0-.17.78l.15.22A.67.67,0,0,0,272.48,178.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.29,191.69l8.87-5.12a.21.21,0,0,0,.06-.31l-.06-.08a.25.25,0,0,0-.33-.07L254,191.23a.21.21,0,0,0-.07.3l.06.09A.26.26,0,0,0,254.29,191.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.43,195.56l10.37-6a.53.53,0,0,0,.17-.78l-.15-.21a.66.66,0,0,0-.85-.19l-10.37,6a.53.53,0,0,0-.17.78l.15.22A.66.66,0,0,0,257.43,195.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.53,184.53l1.52-.88a.53.53,0,0,0,.18-.78l-.15-.21a.66.66,0,0,0-.86-.19l-1.52.88a.53.53,0,0,0-.18.78l.16.21A.64.64,0,0,0,276.53,184.53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.33,197.47l8.87-5.12a.22.22,0,0,0,.07-.31l-.06-.08a.26.26,0,0,0-.33-.08L258,197a.21.21,0,0,0-.07.31l.06.08A.25.25,0,0,0,258.33,197.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.48,201.34l10.36-6a.53.53,0,0,0,.17-.78l-.15-.21a.65.65,0,0,0-.85-.19l-10.37,6a.54.54,0,0,0-.17.78l.15.22A.68.68,0,0,0,261.48,201.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.57,190.31l1.53-.88a.53.53,0,0,0,.17-.78l-.15-.22a.66.66,0,0,0-.85-.19l-1.53.89a.52.52,0,0,0-.17.77l.15.22A.66.66,0,0,0,280.57,190.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.38,203.25l8.87-5.12a.21.21,0,0,0,.06-.31l-.06-.09a.26.26,0,0,0-.33-.07l-8.87,5.12a.22.22,0,0,0-.07.31l.06.08A.27.27,0,0,0,262.38,203.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.52,207.11l10.37-6a.53.53,0,0,0,.17-.78l-.15-.22a.66.66,0,0,0-.85-.19l-10.37,6a.53.53,0,0,0-.17.78l.15.21A.65.65,0,0,0,265.52,207.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.62,196.09l1.53-.88a.54.54,0,0,0,.17-.78l-.15-.22a.66.66,0,0,0-.85-.19l-1.53.88a.53.53,0,0,0-.17.78l.15.22A.65.65,0,0,0,284.62,196.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.42,209l8.87-5.12a.21.21,0,0,0,.07-.3l-.06-.09a.25.25,0,0,0-.33-.07l-8.87,5.12a.21.21,0,0,0-.07.3l.06.09A.25.25,0,0,0,266.42,209Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.57,212.89l10.36-6a.53.53,0,0,0,.17-.78l-.15-.22a.66.66,0,0,0-.85-.19l-10.36,6a.54.54,0,0,0-.18.78l.16.22A.65.65,0,0,0,269.57,212.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.66,201.86l1.53-.88a.53.53,0,0,0,.17-.78l-.15-.21a.65.65,0,0,0-.85-.19l-1.53.88a.53.53,0,0,0-.17.78l.15.21A.65.65,0,0,0,288.66,201.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.47,214.8l8.87-5.12a.21.21,0,0,0,.06-.31l-.06-.08a.24.24,0,0,0-.33-.07l-8.87,5.12a.21.21,0,0,0-.07.3l.06.09A.28.28,0,0,0,270.47,214.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.37,166,263,167.31a.26.26,0,0,1-.34-.08l0,0a.22.22,0,0,1,.07-.31l2.35-1.36a.27.27,0,0,1,.34.08l0,0A.22.22,0,0,1,265.37,166Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.92,166.73l-2.36,1.36a.25.25,0,0,1-.33-.08l0,0a.21.21,0,0,1,.06-.31l2.36-1.36a.25.25,0,0,1,.33.08l0,0A.21.21,0,0,1,265.92,166.73Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.46,167.51l-2.35,1.36a.27.27,0,0,1-.34-.08l0,0a.22.22,0,0,1,.07-.31l2.35-1.36a.26.26,0,0,1,.34.08l0,0A.22.22,0,0,1,266.46,167.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,167.47a.17.17,0,0,1-.13-.07.16.16,0,0,1,0-.21l1.47-.84a.15.15,0,1,1,.15.25l-1.47.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,167.74a.13.13,0,0,1-.12-.06l-1-1.39a.15.15,0,1,1,.25-.17l1,1.39a.14.14,0,0,1,0,.2A.11.11,0,0,1,262.2,167.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,174.82l.46-.84a.1.1,0,0,1,.17,0l.58.82a.11.11,0,0,1-.09.16l-1,0A.1.1,0,0,1,241,174.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.51,174.75a.15.15,0,0,1-.08-.27l1.49-.86a.15.15,0,0,1,.2.06.15.15,0,0,1-.06.2l-1.48.85A.1.1,0,0,1,241.51,174.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3,166.56l3.65,1.81a.4.4,0,0,1,0,.71l-3.39,2a.41.41,0,0,1-.61-.33l-.25-3.76A.4.4,0,0,1,279.3,166.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.2,174.72a.61.61,0,0,1-.48-.25L279.85,169a.59.59,0,0,1,.15-.81.58.58,0,0,1,.8.14l3.87,5.53a.58.58,0,0,1-.14.8A.59.59,0,0,1,284.2,174.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,188.7l-3.65-1.81a.4.4,0,0,1,0-.71l3.39-2a.41.41,0,0,1,.61.32l.25,3.77A.4.4,0,0,1,294,188.7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,187.22a.57.57,0,0,1-.47-.25l-3.87-5.52a.58.58,0,1,1,.95-.66l3.87,5.52a.58.58,0,0,1-.15.81A.56.56,0,0,1,293,187.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.82,213.45a9,9,0,0,0,3.63-3.78,22.06,22.06,0,0,0,2.15-4.84,16.76,16.76,0,0,0,0-9.52c-.06-.2-.42-.33-.38,0a22.65,22.65,0,0,1-.31,9.17,20.88,20.88,0,0,1-2.16,4.94,40.85,40.85,0,0,1-2.91,3.91s0,.17,0,.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.18,198.74A4.25,4.25,0,0,0,247.8,197a6.54,6.54,0,0,0,.81-2.66l-.57-.18a8,8,0,0,0,1,2.62,8.69,8.69,0,0,0,.84,1.15,5.13,5.13,0,0,0,.51.53.93.93,0,0,0,.57.29c.1,0,.09-.18.07-.23a3.74,3.74,0,0,0-.78-1,8.69,8.69,0,0,1-.75-1,8.06,8.06,0,0,1-.93-2.32c0-.21-.53-.44-.56-.1a6.27,6.27,0,0,1-.72,2.57,6.56,6.56,0,0,1-1.25,1.85c-.09.07,0,.34.11.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.26,218.33l-.69.4-1.2-1.71a1.48,1.48,0,0,0-1.91-.43l-1.39.81a1.19,1.19,0,0,0-.39,1.75l1.2,1.71-.69.4a.28.28,0,0,0-.09.42l2,2.82a2.18,2.18,0,0,0,2.82.63l2.24-1.29a1.76,1.76,0,0,0,.57-2.58l-2-2.82A.35.35,0,0,0,147.26,218.33Zm-4.81.38a.4.4,0,0,1,.13-.58l1.39-.81a.5.5,0,0,1,.64.14l1.19,1.71-2.16,1.25Zm4.49,3.69.65.73-.76.43-.47-.83a1,1,0,0,1-1-.4.82.82,0,0,1,.26-1.19,1,1,0,0,1,1.3.29A.79.79,0,0,1,146.94,222.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.34,210.31a19.59,19.59,0,0,0-4.56-2.26,46.62,46.62,0,0,0-4.66-1.46A45.25,45.25,0,0,0,178,205a28.68,28.68,0,0,0-10.06,1.54,41.85,41.85,0,0,0-4.79,1.9,19.88,19.88,0,0,0-3.88,2.22,12.06,12.06,0,0,0-3.11,3.56,7.85,7.85,0,0,0-.85,2.11,7,7,0,0,0,0,2.33c0,.25.38.43.42.09a6.24,6.24,0,0,1,.39-1.34c.11-.36.19-.72.32-1.08a11.31,11.31,0,0,1,.83-1.76,11.49,11.49,0,0,1,2.67-3,17.52,17.52,0,0,1,3.64-2.15,42,42,0,0,1,4.28-1.78,28.93,28.93,0,0,1,9.33-1.75,39.78,39.78,0,0,1,9.2,1.28,44.78,44.78,0,0,1,9.87,3.44c.14.07.17-.25.08-.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.14,215.92a16.49,16.49,0,0,0,1.13,1.84c.36.56.73,1.13,1.07,1.71.12.19.51.43.66.13a7.85,7.85,0,0,1,4.88-3.54c.45-.14,0-.82-.4-.74.42-.09,0,0-.12,0a2.22,2.22,0,0,0-.37.09,7,7,0,0,0-.87.32,9,9,0,0,0-1.5.81,6.9,6.9,0,0,0-2.31,2.52l.66.13c-.37-.6-.76-1.2-1.16-1.79a15,15,0,0,0-1.35-1.82c-.23-.24-.43.09-.32.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.84,138.16,269.39,124a1.25,1.25,0,0,0,.41-1.84l-.36-.51a1.56,1.56,0,0,0-2-.46l-24.55,14.18a1.26,1.26,0,0,0-.41,1.85l.36.51A1.56,1.56,0,0,0,244.84,138.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.49,142l21.21-12.25a.49.49,0,0,0,.16-.73l-.14-.2a.62.62,0,0,0-.8-.18l-21.21,12.25a.5.5,0,0,0-.16.73l.14.2A.63.63,0,0,0,246.49,142Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.35,165.42a2.19,2.19,0,0,1-1.81-.92L218.8,149.16a1.82,1.82,0,0,1-.31-1.49,1.84,1.84,0,0,1,.9-1.2l16.16-9.33a2.21,2.21,0,0,1,2.86.64l10.74,15.34a1.82,1.82,0,0,1,.31,1.49,1.84,1.84,0,0,1-.9,1.2l-16.16,9.33A2.07,2.07,0,0,1,231.35,165.42Zm5.26-28a1.53,1.53,0,0,0-.77.2L219.68,147a1.28,1.28,0,0,0-.62.82,1.26,1.26,0,0,0,.22,1L230,164.17a1.62,1.62,0,0,0,2.09.46l16.16-9.33a1.28,1.28,0,0,0,.62-.82,1.26,1.26,0,0,0-.22-1l-10.74-15.35A1.61,1.61,0,0,0,236.61,137.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.32,149.59l7.74,7.45a2.37,2.37,0,0,0-.64.4,1.94,1.94,0,0,0-.23,2.88,2.34,2.34,0,0,0,3.12-.09,1.93,1.93,0,0,0,.22-2.87l-6.25-6,5.79-5.1h0L240,151a2.37,2.37,0,0,0-.65.41,1.94,1.94,0,0,0-.23,2.87,2.34,2.34,0,0,0,3.12-.09,1.93,1.93,0,0,0,.23-2.87h0l-9.09-8.76Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,137.29a5.94,5.94,0,0,0-1.64,1,9.28,9.28,0,0,1-1.11.41c-.34.17-.39.53-.67.76-.44.35-1.11,0-1.4.65-.14.29-.21,1.34-.89.74a4.1,4.1,0,0,1-.56-.82c-.12-.18-.5-.28-.58,0-.24.69-.09,1.55-.49,2.19-.22.34-.48.33-.69.16a3.49,3.49,0,0,0-.05-2.07.4.4,0,0,0-.49-.22c-.87.46-.73,1.75-.07,2.47a1.68,1.68,0,0,1-.89.87c-.34.12-.7.11-.92.4s-.21.59-.42.85c-.18-.17-.36-.33-.52-.51s-.22-.15-.28,0a6.52,6.52,0,0,1-.55.82c-.3-.76-.53-1.59-1.41-1.95a.12.12,0,0,0-.13,0,3.11,3.11,0,0,0-.79,1.7c0,.12.23.29.25.11a2.33,2.33,0,0,1,.43-1.07c.24-.34.34-.63.85.08a8.8,8.8,0,0,1,.61,1.49c0,.08.23.28.34.17a5.93,5.93,0,0,0,.65-.95,3.34,3.34,0,0,1,.45.47c.06.1.22.19.33.12.44-.31.35-.92.83-1.16s1-.21,1.41-.78a2.29,2.29,0,0,0,.16-.31,1.43,1.43,0,0,0,.5.18c1.22.16,1.39-1.08,1.47-2.06a1.3,1.3,0,0,0,.78.59,1,1,0,0,0,1.27-.85c.11-.34.11-.49.54-.59.13,0,.28,0,.41,0,.4-.12.47-.46.7-.74s.9-.43,1.32-.72a5.32,5.32,0,0,1,1.49-1C271.52,137.65,271.2,137.22,271,137.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.29,131.46c-.34.37-.41.93-.74,1.32a1.16,1.16,0,0,1-1.52.14c-.08,0-.26-.07-.31,0a4.57,4.57,0,0,0-.36,1.08,1.2,1.2,0,0,1-.95-.35c-.09-.12-.43-.3-.54-.11-.19.35-.32.81-.76,1s-.95-.19-1.26-.53c-.15-.18-.58-.27-.64,0a6,6,0,0,0,0,1.27,1.11,1.11,0,0,1-.13.62c-.18.27-.62.43-.73,0s-.75-.47-.68-.08a1.19,1.19,0,0,0,1.94.64c.52-.45.36-1.11.32-1.73a2,2,0,0,0,1.28.39,1.34,1.34,0,0,0,1.19-.94,2.66,2.66,0,0,0,1.36.37.18.18,0,0,0,.2-.13,5.31,5.31,0,0,0,.25-1,1.66,1.66,0,0,0,1.63,0,2.17,2.17,0,0,0,.92-1.75C280.73,131.51,280.43,131.32,280.29,131.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.09,143.18c-.51,0-1.83-.52-2.22-.05-.05.06,0,.2-.08.27a2,2,0,0,1-.53.65c-.47.4-.87,0-1.32-.27a.26.26,0,0,0-.28,0c-.56.63-.55,1.44-1,2.1a.79.79,0,0,1-.9.41,1.44,1.44,0,0,0-.62,0c-.57.15-.68.6-.83,1.07-.34,1-1-.16-1.44-.52-.16-.12-.42-.2-.51,0-.36.84-.57,2.22-1.54,2.64v0c0-.16-.36-.43-.4-.19a1.64,1.64,0,0,0,0,.44.35.35,0,0,0,.34.3c1.33-.17,1.64-1.55,2.08-2.56.38.48.67,1,1.46.9s.61-.89,1-1.34.52-.14.87-.12a1.08,1.08,0,0,0,.75-.19c.84-.59.74-1.63,1.14-2.44.67.43,1.21.63,1.84,0,.22-.23.39-.73.64-.82.58-.22,1.24.33,1.84.14C271.58,143.5,271.24,143.19,271.09,143.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.32,136.81c-.2.28-.38.61-.74.73a1.41,1.41,0,0,1-1.06-.15c-.15-.08-.37-.12-.43.06-.3.79-1.14,2.37-2.18,1.18-.15-.17-.57-.28-.63,0a3.78,3.78,0,0,1-.53,1.32,1.13,1.13,0,0,1-.45.47c-.23.07-.28-.17-.38-.37s-.6-.39-.66-.08a3.24,3.24,0,0,1-.72,1.34c-.1.13-.28.4-.47.42s0,0,0,0-.22-.32-.27-.43c-.15-.33-1-.41-.78,0,.32.78,1.1,1.42,1.93.82a2.56,2.56,0,0,0,.89-1.35,1,1,0,0,0,1.26,0,2.78,2.78,0,0,0,.88-1.45,1.63,1.63,0,0,0,1.6.16,2.24,2.24,0,0,0,1.12-1.54,2.19,2.19,0,0,0,1.21.14,1.23,1.23,0,0,0,.92-.92C280.83,136.94,280.47,136.61,280.32,136.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.86,135.64a.23.23,0,0,0-.14,0l-.16.05a.32.32,0,0,0-.09,0l-.16,0-.14,0h0a.2.2,0,0,0-.17,0,.12.12,0,0,0-.07.12.24.24,0,0,0,.07.16.38.38,0,0,0,.18.13,1,1,0,0,0,.46,0,.8.8,0,0,0,.21-.05.46.46,0,0,0,.18-.16v0a.2.2,0,0,0,0-.07.25.25,0,0,0-.07-.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.34,147.45a4.75,4.75,0,0,1-2.09,0c-.05,0-.13,0-.15,0-.18.47-.16.94-.62,1.27a1.27,1.27,0,0,1-1.66-.13c-.11-.1-.36-.14-.37.05s0,1.12-.22.93-.37-.13-.41,0a2.76,2.76,0,0,1-.31,1,1,1,0,0,1-.47.3,1.08,1.08,0,0,1-.5,0c-.23,0-.35-.05-.52.14s-.25.82-.58.5c-.08-.08-.41-.25-.45,0a1.82,1.82,0,0,1-.11.46c-.14.36-.27.62-.7.52s-.52-.41-.82-.65c-.1-.09-.29-.14-.36,0-.4.72-.51,1.49-1.21,2-.13.11.12.41.26.31a4.53,4.53,0,0,0,1.3-1.84c.29.33.54.71,1.06.72s.9-.52,1-1a.55.55,0,0,0,.51.07,1.13,1.13,0,0,0,.37-.35,1,1,0,0,0,.12-.17c.14-.2,0-.15.24-.19a4.79,4.79,0,0,0,.52,0,1.68,1.68,0,0,0,.65-.3,1.78,1.78,0,0,0,.47-1c.55.19.61-.46.61-1a1.81,1.81,0,0,0,1.7.2,1.37,1.37,0,0,0,.85-1.49,3.06,3.06,0,0,0,2.05,0C274.73,147.74,274.51,147.43,274.34,147.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.23,141a.64.64,0,0,0-.42.11l-.4.16a7.49,7.49,0,0,1-.77.23l-.85.21s-.07-.05-.08,0l0,0c-.23.07-.46.13-.68.22s0,.25.12.21a2.92,2.92,0,0,1,.4-.1,0,0,0,0,1,0,0,1.09,1.09,0,0,1-.13.17.34.34,0,0,1-.12.12.53.53,0,0,1-.16.09l-.07,0H282a.53.53,0,0,1-.36-.22s-.12-.08-.16,0a.11.11,0,0,0,0,.12s0,0,0,.05c-.1.51,0,1.08-.3,1.52a1.77,1.77,0,0,1-1.33.6h-.23a.57.57,0,0,0,0-.18.91.91,0,0,0-.6-.59c-.2,0-.25.11-.26.27a.77.77,0,0,0,.32.6c-.24.39-1,.61-1.15.09-.05-.14-.37-.31-.41-.09a3.37,3.37,0,0,1-.24,1.33c-.26.44-.75.37-1.22.22s-.31.36,0,.45a1.29,1.29,0,0,0,2-1.37,1.08,1.08,0,0,0,1.3,0,.76.76,0,0,0,.25-.34,2.47,2.47,0,0,0,1.66-.16,1.46,1.46,0,0,0,.63-2.06.65.65,0,0,0,1-.4,1.06,1.06,0,0,0,0-.31l1.06-.19a4.34,4.34,0,0,0,.88-.21c.19-.08.59-.22.56-.46C285.32,141.11,285.29,141,285.23,141Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.49,233.79c-.37.6-1.3,1.34-2.09.61-.11-.09-.31-.15-.34,0a6.79,6.79,0,0,1-.44,1.54c-.18.41-.94,1.7-1.39.7-.08-.19-.53-.39-.61-.11-.25.82-.44,2-1.46,2.25a1.15,1.15,0,0,1-.64,0,1.43,1.43,0,0,0,0-1.19.47.47,0,0,0-.55-.29.87.87,0,0,0-.37,1.51.34.34,0,0,1-.06.06,4.2,4.2,0,0,1-1.44.66c-.3.06-.48,0-.66.25s0,.45-.19.61a.94.94,0,0,1-1,.07c-.08-.07-.25-.14-.34-.05a5.08,5.08,0,0,0-.58,1c-.25.5-.56,1.07-1.1.33-.07-.1-.27-.22-.36-.08a5.41,5.41,0,0,1-1.17,1.6c-.46-.66-.92-1.79-1.82-1.87-1.05-.09-1.38,1.39-1.47,2.09,0,.11.22.29.25.14.1-.64.65-2.51,1.71-1.71.56.43.81,1.19,1.24,1.72a.22.22,0,0,0,.27.07,4.15,4.15,0,0,0,1.26-1.56c.28.31.65.57,1.06.31s.69-1.07,1.05-1.56a1.18,1.18,0,0,0,1.18,0c.34-.13.47-.2.56-.52,0-.07,0-.29.09-.35s.41,0,.57-.06a3.75,3.75,0,0,0,1.56-.82,1.76,1.76,0,0,0,.2.09c1.53.53,2.51-.85,2.78-2.08a1,1,0,0,0,1.51-.16,3.26,3.26,0,0,0,.85-2.24c.9.35,2,.2,2.26-.8C239.83,233.89,239.58,233.64,239.49,233.79Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.89,227.56c-.29.66-1.33,1-2,1-.51,0-.71.13-.79.6-.05.3-.18.36-.47.5a3.09,3.09,0,0,1-.68.26,1.64,1.64,0,0,1-1.84-.51c-.07-.1-.29-.23-.37-.08a3,3,0,0,1-.79,1.19c-.52.41-1.25.68-1.65,0-.09-.16-.57-.32-.53,0a2.76,2.76,0,0,1-.18,1.92,2,2,0,0,1-1.89.66c-.4,0-.07.46.2.49a2.53,2.53,0,0,0,2.22-.63,2,2,0,0,0,.38-1.68,1.6,1.6,0,0,0,1.42,0,2.41,2.41,0,0,0,1.28-1.29,2.92,2.92,0,0,0,3.23,0,.64.64,0,0,0,.42-.54c0-.05,0-.28,0-.33s.46,0,.64-.06a4.27,4.27,0,0,0,1.14-.39,1.21,1.21,0,0,0,.79-.84C252.44,227.61,252,227.31,251.89,227.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.74,242.52c-.36.54-1,2.11-2,1.23-.16-.15-.58-.29-.63,0A1.67,1.67,0,0,1,229.8,245a.23.23,0,0,0-.28.13,1.53,1.53,0,0,1-2,1,.18.18,0,0,0-.26.15c0,.6-.41.69-.84,1a1.45,1.45,0,0,0-.83.11c-.25.16-.35.53-.48.82a7.48,7.48,0,0,0-1.12-.9c-.05,0-.13-.05-.17,0a2.69,2.69,0,0,0-.65.89c-.06.14.23.42.31.25a2.51,2.51,0,0,1,.55-.74c.39.28.71.63,1.08.94.09.08.24.14.32,0s.23-.58.43-.77a1.35,1.35,0,0,1,.57-.21.23.23,0,0,0,.28.05c.55-.38.95-.44,1.07-1.07a1.92,1.92,0,0,0,2.31-1.14,2.17,2.17,0,0,0,2.67-1.16,1.52,1.52,0,0,0,1.45.06,2,2,0,0,0,1.12-1.65C235.29,242.57,234.89,242.31,234.74,242.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.61,241.5h0l-.13.07-.21.15a3.09,3.09,0,0,0-.39.33h0a10.46,10.46,0,0,0-.81-1.13c-.27-.33-.56-.65-.85-1-.12-.13-.55-.21-.5.06a3,3,0,0,1-.68,2.26c-.15.21.33.56.49.35a3.85,3.85,0,0,0,.81-1.82,12.26,12.26,0,0,1,.76,1,7,7,0,0,1,.39.67c-.1.12-.22.22-.3.34a2,2,0,0,0-.45,1.8.52.52,0,0,0,.55.29,1.56,1.56,0,0,0,1.06-.7,1.46,1.46,0,0,0,0-1.05,2.6,2.6,0,0,0-.13-.36c.1-.11.19-.23.29-.33l.33-.31a1.43,1.43,0,0,0,.27-.28C240.24,241.69,239.84,241.42,239.61,241.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.22,231.17c-.55.19-1.47.34-1.76.87-.12.21,0,.62-.23.79s-.54,0-.77,0a4.5,4.5,0,0,0-1,.24,5.85,5.85,0,0,1-1.1.17c-.52,0-.43.28-.59.66s-.65.64-.89,1,0,.53-.43.55c-.24,0-.5-.21-.75-.22s-.71.38-.89.65c-.44.63-.6.85-1.56.58a.32.32,0,0,0-.36.08,3.39,3.39,0,0,1-.69,1.12c-.43.32-.93-.06-1.32-.31-.16-.1-.54-.13-.61.09-.25.79-1,2.22-2.09,1.33-.28-.24-.7,0-.4.26,1.26,1.33,2.61.27,3.16-.94a2,2,0,0,0,1.52.27,1.84,1.84,0,0,0,1.05-1.32,1.79,1.79,0,0,0,1.27,0c.38-.21.5-.65.7-1,.41-.67.79,0,1.38-.15a.51.51,0,0,0,.34-.33,2.52,2.52,0,0,1,.39-.61,4.85,4.85,0,0,0,.54-.57,3.2,3.2,0,0,1,.29-.51c.21-.2.42-.08.73-.12a13,13,0,0,1,1.48-.41c.5,0,.95.25,1.2-.32.16-.34,0-.62.39-.89a10.72,10.72,0,0,1,1.29-.57C254.71,231.43,254.42,231.1,254.22,231.17Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.22,212.64c-1.59,1.44-2.12,3.8-2.41,5.82a27.61,27.61,0,0,0,0,7.81,24.47,24.47,0,0,0,2.69,7.78,23.41,23.41,0,0,0,6,7.41,13.71,13.71,0,0,0,8.93,3.43c.25,0,.06-.38-.11-.41a17.31,17.31,0,0,1-4.15-.92,14.22,14.22,0,0,1-3.53-2.07,22.73,22.73,0,0,1-5.86-6.68,25,25,0,0,1-3-7.61,26.92,26.92,0,0,1-.37-7.17,13.5,13.5,0,0,1,2.17-7.1c.11-.14-.16-.42-.3-.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.2,246a27.61,27.61,0,0,1,3-.73,12.81,12.81,0,0,1,2.9-.11c.26,0,.45-.26.18-.43-.8-.52-1.68-.93-2.52-1.4a10.29,10.29,0,0,1-1.21-.77,5.59,5.59,0,0,1-.52-.45l-.21-.22c-.09-.08-.21-.23-.32-.32s-.13-.08-.19-.14-.26-.07-.2.09,0,.19,0,.29a2,2,0,0,0,.2.31,3.14,3.14,0,0,0,.5.53,8.84,8.84,0,0,0,1.29.91c.92.53,1.91,1,2.81,1.54l.19-.43a13.45,13.45,0,0,0-3.17.12,13.72,13.72,0,0,0-1.57.35,5.17,5.17,0,0,0-1.37.52c-.17.1.07.38.22.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.21,159.75c-.06.43-.07.85-.46,1.14a2.43,2.43,0,0,1-1.15.39,6.43,6.43,0,0,1-2.43-.15c-.1,0-.27,0-.28.14,0,.9-.46,2.06-1.69,1.62a1.23,1.23,0,0,1-.26-.12,1.73,1.73,0,0,0-.25-1.74c-.08-.12-.31-.26-.46-.16-.78.5-.61,1.25-.09,1.81a2,2,0,0,1-1.88.77c-.16,0-.31.08-.28.24.11.56.28,1.48-.34,1.82s-1.33,0-1.84-.24c-.14-.06-.47-.11-.48.12a4,4,0,0,1-.34,1.31,2.55,2.55,0,0,1-.45-.42c-.09-.12-.56-.32-.57,0a4.62,4.62,0,0,1-.16.84,2.6,2.6,0,0,0-2.15-1.43.14.14,0,0,0-.11.06c-.25.42-.08.63.09,1,.08.21.48.28.37,0-.05-.13-.25-.49-.15-.6.22-.27.88.18,1,.32a2.67,2.67,0,0,1,.75,1.41c0,.16.46.4.52.15s.23-.73.33-1.1a5.34,5.34,0,0,1,.44.39c.17.16.55.28.63,0a10.83,10.83,0,0,0,.44-1.44,2.85,2.85,0,0,0,2.08.16c.8-.36.76-1.3.64-2a2.52,2.52,0,0,0,2-.87l.14.09a2.13,2.13,0,0,0,1.67.16,1.84,1.84,0,0,0,1-1.69c1.57.27,5.25.24,4.18-1.85C304.64,159.73,304.24,159.52,304.21,159.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.35,166.24c-.38.1-.62.42-.93.63s-.8.48-1.21.71c-.75.41-1.64.57-2.37,1a11.75,11.75,0,0,0-1.44,1.18,1.62,1.62,0,0,1-2,.23c-.15-.08-.52-.07-.5.16a2.29,2.29,0,0,1-.53,1.53,2.25,2.25,0,0,1-.46.41l0-.06a.91.91,0,0,0-.18-.37c-.07-.1-.26-.21-.35-.08-.46.67.49,1.36,1.16,1a2.6,2.6,0,0,0,1.13-1.88,2.29,2.29,0,0,0,1.63,0,6.28,6.28,0,0,0,1.59-1.2,9.38,9.38,0,0,1,2.39-1.13,8.37,8.37,0,0,0,2.47-1.59.2.2,0,0,0,0-.21,1,1,0,0,0-.07-.15A.32.32,0,0,0,303.35,166.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,170.53c.83,1.81,2.13,3.39,3,5.18a16,16,0,0,1-.62,16,17.69,17.69,0,0,1-1.67,2.2A16.25,16.25,0,0,1,301,196c-.25.18.12.6.36.52a9.11,9.11,0,0,0,4.12-3.63,15.43,15.43,0,0,0,2.37-5,16.75,16.75,0,0,0-.93-11.33,23.2,23.2,0,0,0-4.05-6.2c-.13-.14-.21.11-.16.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.23,192.45A5.59,5.59,0,0,0,301,194.9a5.28,5.28,0,0,1-1.08,1.9c-.27.28.17.68.46.64.7-.1,1.36-.34,2.05-.49a4.29,4.29,0,0,1,1-.12,3,3,0,0,1,.42.06,2.12,2.12,0,0,0,.7.21s.19-.07.17-.12-.05-.39-.19-.53l-.13-.1a.9.9,0,0,0-.28-.13,2.32,2.32,0,0,0-.58-.13,4.68,4.68,0,0,0-1.24.08c-.7.13-1.45.41-2.12.51l.47.64a5.48,5.48,0,0,0,1.15-2.12c.26-.8.52-1.6.8-2.39.06-.18-.14-.53-.34-.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.54,265a.5.5,0,0,1-.15.72.61.61,0,0,1-.79-.18.48.48,0,0,1,.16-.71A.6.6,0,0,1,188.54,265Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.22,264a.49.49,0,0,1-.16.72.6.6,0,0,1-.78-.18.48.48,0,0,1,.16-.71A.61.61,0,0,1,190.22,264Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.89,263a.48.48,0,0,1-.16.71.61.61,0,0,1-.78-.17.49.49,0,0,1,.16-.72A.6.6,0,0,1,191.89,263Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--mobile--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.47,275.68a1.18,1.18,0,0,1-1-.49l-31.4-44.84a1,1,0,0,1-.16-.8,1.27,1.27,0,0,1,.6-.79l26.2-15.12a1.3,1.3,0,0,1,1.7.29L206,259a.75.75,0,0,1,.13.59,1.38,1.38,0,0,1-.74.78l-26.19,15.12A1.47,1.47,0,0,1,178.47,275.68Zm-5-61.64a.8.8,0,0,0-.42.11l-26.2,15.12a.67.67,0,0,0-.32.41.42.42,0,0,0,.06.33L178,274.86a.73.73,0,0,0,.92.11l26.2-15.12c.38-.22.44-.35.45-.4s0-.05,0-.12l-31.55-45.07A.64.64,0,0,0,173.44,214Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.08,237.93l8.87-5.12a.21.21,0,0,0,.06-.31l0-.08a.27.27,0,0,0-.34-.08l-8.87,5.12a.21.21,0,0,0-.06.31l.06.08A.25.25,0,0,0,165.08,237.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.4,259.48l-2.65-3.78a.66.66,0,0,0-.85-.19l-.23.13a.54.54,0,0,0-.17.78l2.65,3.78a.66.66,0,0,0,.85.19l.22-.13A.54.54,0,0,0,185.4,259.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.07,257.93l-2.65-3.77a.65.65,0,0,0-.85-.19l-.22.13a.53.53,0,0,0-.18.78l2.65,3.78a.67.67,0,0,0,.85.19l.23-.14A.53.53,0,0,0,188.07,257.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.66,260.93l2.25-.05a.22.22,0,0,0,.18-.35l-1.25-1.79a.23.23,0,0,0-.38,0l-1,1.84A.22.22,0,0,0,178.66,260.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.28,261.85l-1.5-2.13a.37.37,0,0,0-.48-.1l-.12.07a.3.3,0,0,0-.1.44l1.49,2.13a.38.38,0,0,0,.48.11l.13-.08A.3.3,0,0,0,179.28,261.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.11,253.76l-1,1.83a.22.22,0,0,1-.38,0l-1.25-1.78a.23.23,0,0,1,.18-.36l2.25-.05A.23.23,0,0,1,191.11,253.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.79,254.63l-1.5-2.13a.3.3,0,0,1,.1-.44l.13-.07a.37.37,0,0,1,.48.1l1.49,2.13a.3.3,0,0,1-.1.44l-.12.08A.37.37,0,0,1,191.79,254.63Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.77,236.43a.14.14,0,0,1,0-.06,0,0,0,0,1,0,0l0-1.67a2.5,2.5,0,0,1-.76.28,2.11,2.11,0,0,1-.75,0,1.82,1.82,0,0,1-.69-.26,1.91,1.91,0,0,1-.57-.53,1.71,1.71,0,0,1-.29-.69,1.46,1.46,0,0,1,0-.69,1.65,1.65,0,0,1,.34-.62,2.15,2.15,0,0,1,.61-.5,2.53,2.53,0,0,1,.76-.29,2,2,0,0,1,.77,0,2,2,0,0,1,.7.25,1.83,1.83,0,0,1,.76.9,2.37,2.37,0,0,1,.09.36,2.07,2.07,0,0,1,0,.35,1.82,1.82,0,0,1,0,.33l-.06,2.37a.49.49,0,0,1,0,.12.22.22,0,0,1-.11.13l-.59.34a.25.25,0,0,1-.15,0A.23.23,0,0,1,161.77,236.43Zm-1.86-2.78a.88.88,0,0,0,.62.39,1.2,1.2,0,0,0,.74-.17,1,1,0,0,0,.48-.55.69.69,0,0,0-.12-.66.86.86,0,0,0-.62-.39,1.12,1.12,0,0,0-.74.16,1.07,1.07,0,0,0-.49.55A.73.73,0,0,0,159.91,233.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.82,231.1a.29.29,0,0,1,.16,0,.25.25,0,0,1,.13.09l.43.61a.2.2,0,0,1,0,.15.18.18,0,0,1-.09.12l-.61.35a.22.22,0,0,1-.16,0,.18.18,0,0,1-.13-.09l-.43-.6a.21.21,0,0,1,0-.15.14.14,0,0,1,.09-.12Zm1.52,2.18a.18.18,0,0,1,.16,0,.2.2,0,0,1,.13.08l.43.61a.21.21,0,0,1,0,.15.18.18,0,0,1-.09.12l-.61.35a.21.21,0,0,1-.16,0,.3.3,0,0,1-.13-.09l-.43-.61a.21.21,0,0,1,0-.15.18.18,0,0,1,.09-.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,227.52a.29.29,0,0,1,.16,0,.22.22,0,0,1,.14.09l.31.44a.29.29,0,0,1,0,.16l0,.15-.28,1.51a2.13,2.13,0,0,1,.62-.17,1.65,1.65,0,0,1,.59,0,1.48,1.48,0,0,1,.53.23,1.6,1.6,0,0,1,.43.43,1.46,1.46,0,0,1,.27.65,1.28,1.28,0,0,1-.08.64,1.88,1.88,0,0,1-.37.59,2.73,2.73,0,0,1-.64.5,3,3,0,0,1-.87.36,2.43,2.43,0,0,1-.74.06,1.56,1.56,0,0,1-.6-.17,1.19,1.19,0,0,1-.42-.33.15.15,0,0,1,0-.14.19.19,0,0,1,.1-.13l.51-.29a.18.18,0,0,1,.14,0l.17.07.2.08a1,1,0,0,0,.26,0,1.3,1.3,0,0,0,.33-.08,2.56,2.56,0,0,0,.42-.2,1.21,1.21,0,0,0,.53-.52.52.52,0,0,0-.05-.57.55.55,0,0,0-.53-.26,1.72,1.72,0,0,0-.73.25l-.54.31a.18.18,0,0,1-.16,0,.25.25,0,0,1-.14-.08l-.3-.44a.23.23,0,0,1,0-.16.78.78,0,0,1,0-.16l.28-1.44-1.81,1a.22.22,0,0,1-.16,0,.25.25,0,0,1-.13-.09l-.31-.44a.21.21,0,0,1,0-.15.16.16,0,0,1,.09-.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.73,226.51c.05.08.12.16.18.26l.21.29.2.29.18.27a3.47,3.47,0,0,1,.35.73,1.59,1.59,0,0,1,.08.71,1.49,1.49,0,0,1-.29.66,2.34,2.34,0,0,1-.72.6,2.65,2.65,0,0,1-.9.34,1.83,1.83,0,0,1-.78,0,1.86,1.86,0,0,1-.68-.36,4.15,4.15,0,0,1-.58-.6c-.12-.15-.25-.33-.39-.53s-.26-.38-.36-.55a3.09,3.09,0,0,1-.36-.73,1.65,1.65,0,0,1-.08-.72,1.36,1.36,0,0,1,.28-.67,2.21,2.21,0,0,1,.72-.6,2.42,2.42,0,0,1,.89-.34,1.73,1.73,0,0,1,.79,0,1.82,1.82,0,0,1,.67.36A4.2,4.2,0,0,1,172.73,226.51Zm-1.89,2.6a1.77,1.77,0,0,0,.71.56.93.93,0,0,0,.82-.13c.31-.18.47-.38.48-.62a1.39,1.39,0,0,0-.26-.82,6,6,0,0,0-.35-.53c-.13-.19-.26-.36-.38-.52a1.71,1.71,0,0,0-.71-.56,1,1,0,0,0-.82.13.83.83,0,0,0-.48.62,1.52,1.52,0,0,0,.26.83c.1.16.22.33.35.52S170.72,229,170.84,229.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.57,228.87l0,0-.09-.12-.31.18s0,0,0,0l0,0s0,0,0,0,0,0,0,0l0-.63v0l0,0,0,0h0s0,0,0,0l.3.43.07,0h0s0,0,0,0l0,0a0,0,0,0,1,0,0l0,0-.07,0,.08.12s0,0,0,0l0,0-.05,0Zm-.17-.27-.22-.31v.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.89,228.58a.61.61,0,0,1-.3-.24.46.46,0,0,1-.1-.34.35.35,0,0,1,.19-.25l.13-.06H154a0,0,0,0,1,0,0v.07h0a.29.29,0,0,0-.19,0,.27.27,0,0,0-.13.17.37.37,0,0,0,.09.25.42.42,0,0,0,.21.18.28.28,0,0,0,.22,0l.07,0a.13.13,0,0,0,.05-.06l-.14-.2-.13.07h0l0,0,0,0s0,0,0,0l0,0,.21-.12h0l0,0,.2.29,0,0v0a.43.43,0,0,1-.2.2A.4.4,0,0,1,153.89,228.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,227a.2.2,0,0,1-.06.28.24.24,0,0,1-.31-.07.2.2,0,0,1,.06-.28A.24.24,0,0,1,156.51,227Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,226.65a.49.49,0,0,0-.25.48s0,.07.08.08h0s.1,0,.09-.08a.37.37,0,0,1,.18-.35.45.45,0,0,1,.42,0,.08.08,0,0,0,.12,0h0a.08.08,0,0,0,0-.1A.64.64,0,0,0,156,226.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.81,226.37a.8.8,0,0,0-.41.72s0,.07.08.08h0a.08.08,0,0,0,.09-.08.62.62,0,0,1,.34-.58.77.77,0,0,1,.72,0,.09.09,0,0,0,.12,0h0a.09.09,0,0,0-.05-.1A1,1,0,0,0,155.81,226.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.16 230.97 149.99 230.73 150.32 230.53 150.49 230.77 150.16 230.97",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.66 230.67 150.32 230.2 150.66 230 150.99 230.48 150.66 230.67",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.16 230.38 150.66 229.67 151 229.47 151.5 230.19 151.16 230.38",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.67 230.09 151 229.14 151.33 228.94 152 229.9 151.67 230.09",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,216.9a.28.28,0,0,0-.18,0l-1.25.73c-.08,0-.09.16,0,.26l.31.44a.38.38,0,0,0,.16.12l.09,0a.15.15,0,0,0,.09,0l1.25-.72a.19.19,0,0,0,0-.27l-.31-.43A.33.33,0,0,0,172.63,216.9Zm-1,1.49a.13.13,0,0,1-.07-.06l-.31-.43c-.05-.08-.05-.17,0-.21l1.26-.72h.07a.13.13,0,0,1,.07.06l.31.44c.05.07.05.17,0,.2l-1.26.72A.06.06,0,0,1,171.66,218.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.59,217.63l.36.52-.2.11s-.05,0-.06,0l-.27-.38a.11.11,0,0,1,0-.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.68 217.58 171.91 217.44 172.27 217.96 172.04 218.09 171.68 217.58",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172 217.39 172.24 217.25 172.6 217.77 172.37 217.91 172 217.39",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.59,217.1l.26.37c.05.07,0,.15-.08.2l-.08.05-.36-.52.19-.1A.06.06,0,0,1,172.59,217.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.84,217s.12,0,.18.13l0,.08c.07.09.09.18.06.2l-.06,0-.29-.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.35 219.1 170.41 218.16 170.62 219.22 170.12 218.85 169.35 219.1",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,242.72a7,7,0,0,1-3,9,8.68,8.68,0,0,1-9.21-.48L172.8,244l8.4,2.83c.65.21.75.06.21-.35l-2.07-1.35.85-3.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.94,238.84a7.05,7.05,0,0,0-2.27,10.33,8.44,8.44,0,0,0,1,1.15l1.09-7.38a.34.34,0,0,1,.18-.26h0a.4.4,0,0,1,.34,0l5.9,2,1-3.82a.39.39,0,0,1,.48-.25l3.59.84,0,0A8.7,8.7,0,0,0,171.94,238.84Zm4.55,2.18a1.18,1.18,0,0,1-1.53-.34,1,1,0,0,1,.31-1.4,1.16,1.16,0,0,1,1.52.34A1,1,0,0,1,176.49,241Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.52,215.14a.33.33,0,0,1-.28,0A.49.49,0,0,1,115,215l-5.45-7.8a.37.37,0,0,1-.08-.28.33.33,0,0,1,.14-.22l.9-.51a.32.32,0,0,1,.27,0,.42.42,0,0,1,.25.18l5.46,7.79a.36.36,0,0,1,.07.28.28.28,0,0,1-.14.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.47,210.1a.34.34,0,0,1,.07.27.27.27,0,0,1-.14.22l-.84.49a.36.36,0,0,1-.27,0,.42.42,0,0,1-.25-.18l-2.15-3.06a2.61,2.61,0,0,0-1.12-1,1.34,1.34,0,0,0-1.25.11,1.11,1.11,0,0,0-.61,1,2.23,2.23,0,0,0,.47,1.35l2.15,3.07a.41.41,0,0,1,.07.28.28.28,0,0,1-.14.22l-.84.48a.28.28,0,0,1-.27,0,.45.45,0,0,1-.25-.17l-3.94-5.63a.36.36,0,0,1-.07-.28.25.25,0,0,1,.14-.21l.84-.49a.36.36,0,0,1,.27,0,.42.42,0,0,1,.25.18l.2.27a2.46,2.46,0,0,1,.3-.9,2,2,0,0,1,.77-.74,3,3,0,0,1,1.29-.41,2.61,2.61,0,0,1,1.15.19,3.2,3.2,0,0,1,1,.68,6.19,6.19,0,0,1,.88,1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.44,206.23a1.3,1.3,0,0,0,.6.49,1,1,0,0,0,.84-.17l.67-.39a.36.36,0,0,1,.27,0,.42.42,0,0,1,.25.18l.56.79a.37.37,0,0,1,.07.28.27.27,0,0,1-.14.22l-.81.47a2.64,2.64,0,0,1-2,.37,3.09,3.09,0,0,1-1.73-1.36l-1.82-2.59-.73.41a.32.32,0,0,1-.27,0,.42.42,0,0,1-.25-.18l-.56-.8a.4.4,0,0,1-.07-.28.26.26,0,0,1,.14-.21l.73-.42-1.38-2a.36.36,0,0,1-.07-.28.28.28,0,0,1,.14-.22l.84-.48a.28.28,0,0,1,.27,0,.45.45,0,0,1,.25.17l1.38,2,1.42-.82a.32.32,0,0,1,.27,0,.42.42,0,0,1,.25.18l.56.79a.36.36,0,0,1,.07.28.28.28,0,0,1-.14.22l-1.42.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.45,203.85a5.19,5.19,0,0,1-.7-1.39,3.59,3.59,0,0,1-.19-1.35,2.72,2.72,0,0,1,.37-1.18,2.63,2.63,0,0,1,.94-.9,2.9,2.9,0,0,1,1.29-.4,3.48,3.48,0,0,1,1.32.17,4.36,4.36,0,0,1,1.23.67,4.62,4.62,0,0,1,1,1.06l.38.55a.36.36,0,0,1,.08.28.29.29,0,0,1-.14.21l-3.68,2.13a1.49,1.49,0,0,0,.45.42,1.27,1.27,0,0,0,.53.2,1.52,1.52,0,0,0,.56,0,1.93,1.93,0,0,0,.52-.2,2,2,0,0,0,.52-.41,1.18,1.18,0,0,0,.22-.41,1.22,1.22,0,0,1,.11-.25.47.47,0,0,1,.18-.15l.88-.51a.33.33,0,0,1,.28,0,.37.37,0,0,1,.24.18,1.17,1.17,0,0,1,.14.54,2,2,0,0,1-.12.79,2.89,2.89,0,0,1-.48.89,3.27,3.27,0,0,1-1,.81,3.2,3.2,0,0,1-1.28.41,3.35,3.35,0,0,1-1.32-.18,4.22,4.22,0,0,1-1.26-.72A5.94,5.94,0,0,1,127.45,203.85Zm1.43-3.37a1.3,1.3,0,0,0-.47.42,1.1,1.1,0,0,0-.19.48,1.4,1.4,0,0,0,0,.5,1.92,1.92,0,0,0,.17.44l2.48-1.44a2.81,2.81,0,0,0-.35-.33,1.29,1.29,0,0,0-1-.3A1.65,1.65,0,0,0,128.88,200.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,196.8a1.28,1.28,0,0,0-.73.87,1.84,1.84,0,0,0,.44,1.21l2.2,3.14a.41.41,0,0,1,.07.28.28.28,0,0,1-.14.22l-.84.48a.32.32,0,0,1-.27,0,.42.42,0,0,1-.25-.18l-3.94-5.62a.36.36,0,0,1-.07-.28.28.28,0,0,1,.14-.22l.84-.48a.32.32,0,0,1,.27,0,.42.42,0,0,1,.25.18l.2.27a2.24,2.24,0,0,1,.29-.8,2.15,2.15,0,0,1,.75-.65l.49-.28a.33.33,0,0,1,.28,0,.45.45,0,0,1,.25.18l.56.8a.41.41,0,0,1,.07.28.31.31,0,0,1-.14.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.46,195.84a2.12,2.12,0,0,1-.18-.67,2,2,0,0,1,.07-.8,2.6,2.6,0,0,1,.42-.83,3,3,0,0,1,.88-.73,3.21,3.21,0,0,1,1.12-.42,2.59,2.59,0,0,1,1.11,0,2.85,2.85,0,0,1,1.06.5,4.26,4.26,0,0,1,.94,1l2.48,3.55a.35.35,0,0,1,.07.28.25.25,0,0,1-.14.21l-.83.49a.39.39,0,0,1-.28,0,.42.42,0,0,1-.25-.18l-.28-.4a1.94,1.94,0,0,1-.25,1,2.27,2.27,0,0,1-.93.88,2.85,2.85,0,0,1-.94.35,2.31,2.31,0,0,1-.91,0,2.46,2.46,0,0,1-.81-.37,2.8,2.8,0,0,1-.66-.67,1.9,1.9,0,0,1-.37-1.62,3.05,3.05,0,0,1,1-1.47l1.56-1.37a1.08,1.08,0,0,0-.79-.53,1.52,1.52,0,0,0-.88.22.87.87,0,0,0-.37.33,1.57,1.57,0,0,0-.14.4.67.67,0,0,1-.09.24.51.51,0,0,1-.15.14l-1,.59a.31.31,0,0,1-.23,0A.28.28,0,0,1,137.46,195.84Zm4.22,2.34a1.93,1.93,0,0,0,.58-.5,1.68,1.68,0,0,0,.28-.59,1.39,1.39,0,0,0,0-.61,1.61,1.61,0,0,0-.25-.55l-.08-.12L140.9,197a1.42,1.42,0,0,0-.47.63.6.6,0,0,0,.11.55.54.54,0,0,0,.5.24A1.49,1.49,0,0,0,141.68,198.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.72,192.71c.07.13.16.27.27.44a3.72,3.72,0,0,0,.32.4,2.35,2.35,0,0,0,.6.55,1.57,1.57,0,0,0,1.17.27,1.41,1.41,0,0,0,.51-.18,2,2,0,0,0,.43-.32,1.08,1.08,0,0,0,.22-.32,1.05,1.05,0,0,0,.08-.34,2.16,2.16,0,0,0,0-.36,1.6,1.6,0,0,1,0-.31.3.3,0,0,1,.14-.23l.83-.48a.34.34,0,0,1,.28,0,.42.42,0,0,1,.25.18,2.16,2.16,0,0,1,.26.71,2.47,2.47,0,0,1,0,1,2.81,2.81,0,0,1-.44,1,3.11,3.11,0,0,1-1.05.92,2.93,2.93,0,0,1-1.24.41,3.42,3.42,0,0,1-1.27-.12,3.75,3.75,0,0,1-1.18-.56,4.44,4.44,0,0,1-1-.91,3.84,3.84,0,0,1-.36-.47,4.89,4.89,0,0,1-.33-.51,4.19,4.19,0,0,1-.5-1.2,3.32,3.32,0,0,1-.06-1.21,2.75,2.75,0,0,1,.42-1.09,2.78,2.78,0,0,1,.94-.85,3.39,3.39,0,0,1,1.37-.47,3.53,3.53,0,0,1,1.23.08,3,3,0,0,1,1,.42,2.49,2.49,0,0,1,.6.52.3.3,0,0,1,.07.27.27.27,0,0,1-.14.22l-.84.49a.34.34,0,0,1-.28,0,2.22,2.22,0,0,1-.31-.13l-.36-.15a1.53,1.53,0,0,0-.37-.08,1.27,1.27,0,0,0-.42,0,2.07,2.07,0,0,0-.5.22,1.37,1.37,0,0,0-.39.33,1.19,1.19,0,0,0-.23.48,1.34,1.34,0,0,0,0,.6A2.31,2.31,0,0,0,145.72,192.71Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.74,189.89a1.3,1.3,0,0,0,.6.49,1,1,0,0,0,.83-.17l.68-.38a.32.32,0,0,1,.27,0,.42.42,0,0,1,.25.18l.56.8a.36.36,0,0,1,.07.28.25.25,0,0,1-.14.21l-.81.48a2.64,2.64,0,0,1-2,.36,3.05,3.05,0,0,1-1.73-1.36l-1.82-2.59-.73.42a.36.36,0,0,1-.27,0,.42.42,0,0,1-.25-.18l-.56-.79a.37.37,0,0,1-.07-.28.28.28,0,0,1,.14-.22l.73-.42-1.38-2a.36.36,0,0,1-.07-.28.28.28,0,0,1,.14-.22l.83-.48a.38.38,0,0,1,.28,0,.45.45,0,0,1,.25.18l1.38,2,1.42-.82a.36.36,0,0,1,.27,0,.42.42,0,0,1,.25.18l.56.79a.42.42,0,0,1,.07.28.28.28,0,0,1-.14.22l-1.42.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.42,181.23a.34.34,0,0,1,.28,0,.42.42,0,0,1,.25.18l.66.94a.36.36,0,0,1,.07.28.28.28,0,0,1-.14.22l-.95.55a.36.36,0,0,1-.27,0,.42.42,0,0,1-.25-.18l-.66-.94a.36.36,0,0,1-.07-.28.28.28,0,0,1,.14-.22Zm6,8.1a.41.41,0,0,1,.07.28.28.28,0,0,1-.14.22l-.84.48a.32.32,0,0,1-.27,0,.42.42,0,0,1-.25-.18l-3.94-5.62a.36.36,0,0,1-.07-.28.28.28,0,0,1,.14-.22l.84-.48a.32.32,0,0,1,.27,0,.42.42,0,0,1,.25.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.23,180.93a3.07,3.07,0,0,1,1.24-.43,3.24,3.24,0,0,1,1.24.08,3.64,3.64,0,0,1,1.16.51,4,4,0,0,1,1,.9,1.72,1.72,0,0,1,.2.27l.24.34.23.33a2.1,2.1,0,0,1,.18.28,4,4,0,0,1,.48,1.18,3.08,3.08,0,0,1,0,1.17,2.88,2.88,0,0,1-.46,1.05,3,3,0,0,1-1,.83,3.12,3.12,0,0,1-1.24.43,3.45,3.45,0,0,1-1.24-.07,3.68,3.68,0,0,1-1.15-.51,4.35,4.35,0,0,1-1-.89l-.21-.27q-.12-.15-.24-.33l-.23-.34-.18-.28a4.08,4.08,0,0,1-.48-1.18,3.35,3.35,0,0,1,0-1.18,2.75,2.75,0,0,1,1.41-1.89Zm3.23,1.94a2.79,2.79,0,0,0-.59-.53,1.83,1.83,0,0,0-.59-.21,1.42,1.42,0,0,0-.55,0,3,3,0,0,0-.49.2,2.15,2.15,0,0,0-.41.32,1.21,1.21,0,0,0-.27.43,1.22,1.22,0,0,0,0,.58,1.9,1.9,0,0,0,.28.71,2.72,2.72,0,0,0,.15.25l.2.31.23.3c.07.1.13.17.18.23a2.38,2.38,0,0,0,.59.53,1.83,1.83,0,0,0,.59.21,1.45,1.45,0,0,0,.55,0,3,3,0,0,0,.49-.2,2.15,2.15,0,0,0,.41-.32,1.21,1.21,0,0,0,.27-.43,1.36,1.36,0,0,0,0-.58,2.08,2.08,0,0,0-.28-.71,2.06,2.06,0,0,0-.15-.24l-.22-.31c-.07-.1-.14-.21-.21-.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.88,181.57a.41.41,0,0,1,.07.28.28.28,0,0,1-.14.22l-.84.48a.33.33,0,0,1-.28,0,.46.46,0,0,1-.24-.17l-2.15-3.07a2.68,2.68,0,0,0-1.12-1,1.37,1.37,0,0,0-1.25.11,1.16,1.16,0,0,0-.62,1,2.19,2.19,0,0,0,.48,1.35l2.15,3.06a.42.42,0,0,1,.07.28.29.29,0,0,1-.14.22l-.84.49a.38.38,0,0,1-.28,0,.43.43,0,0,1-.24-.18l-3.94-5.62a.36.36,0,0,1-.07-.28.28.28,0,0,1,.14-.22l.83-.48a.34.34,0,0,1,.28,0,.45.45,0,0,1,.25.18l.19.28a2.73,2.73,0,0,1,.31-.91,2,2,0,0,1,.77-.73,2.87,2.87,0,0,1,1.29-.42,2.64,2.64,0,0,1,1.15.2,3.16,3.16,0,0,1,1,.67,6.52,6.52,0,0,1,.87,1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.28,169.36a4.24,4.24,0,0,1,1.58-.58,3.3,3.3,0,0,1,1.47.09,3.94,3.94,0,0,1,1.35.69,6.77,6.77,0,0,1,1.22,1.23c.45.58.86,1.17,1.25,1.78a6.31,6.31,0,0,1,.71,1.53,3.41,3.41,0,0,1,.12,1.4,2.65,2.65,0,0,1-.52,1.24,3.8,3.8,0,0,1-1.21,1l-2.78,1.6a.32.32,0,0,1-.27,0,.42.42,0,0,1-.25-.18l-5.46-7.8a.35.35,0,0,1-.07-.28.26.26,0,0,1,.14-.21Zm4.13,2.28a3.18,3.18,0,0,0-.64-.63,2.29,2.29,0,0,0-.74-.39,2.15,2.15,0,0,0-.84-.05,2.2,2.2,0,0,0-.91.33l-1.48.85,3.81,5.43,1.53-.89a2.1,2.1,0,0,0,.68-.58,1.5,1.5,0,0,0,.28-.7,1.75,1.75,0,0,0-.06-.78,4.09,4.09,0,0,0-.37-.8C179.28,172.82,178.86,172.22,178.41,171.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.34,172.16a5.19,5.19,0,0,1-.7-1.39,3.38,3.38,0,0,1-.19-1.34,2.6,2.6,0,0,1,.37-1.19,2.55,2.55,0,0,1,.94-.9,2.9,2.9,0,0,1,1.29-.4,3.48,3.48,0,0,1,1.32.17,4.36,4.36,0,0,1,1.23.67,4.85,4.85,0,0,1,1,1.06l.38.55a.32.32,0,0,1,.07.28.26.26,0,0,1-.14.21L184.25,172a1.58,1.58,0,0,0,.44.42,1.54,1.54,0,0,0,.54.2,1.46,1.46,0,0,0,.55,0,1.94,1.94,0,0,0,1-.61,1.06,1.06,0,0,0,.23-.41,1.28,1.28,0,0,1,.1-.25.63.63,0,0,1,.19-.15l.88-.51a.33.33,0,0,1,.28,0,.37.37,0,0,1,.24.18,1.31,1.31,0,0,1,.14.54,2.14,2.14,0,0,1-.12.79,2.89,2.89,0,0,1-.48.89,3.27,3.27,0,0,1-1,.81,3.2,3.2,0,0,1-1.28.41,3.33,3.33,0,0,1-1.32-.18,4.22,4.22,0,0,1-1.26-.72A5.94,5.94,0,0,1,182.34,172.16Zm1.43-3.37a1.3,1.3,0,0,0-.47.42,1.1,1.1,0,0,0-.19.48,1.2,1.2,0,0,0,0,.5,1.91,1.91,0,0,0,.16.44l2.49-1.44a2.81,2.81,0,0,0-.35-.33,1.29,1.29,0,0,0-1-.3A1.6,1.6,0,0,0,183.77,168.79Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,167.88a.48.48,0,0,0-.23-.17,1,1,0,0,0-.38,0c-.16,0-.37.08-.61.15l-.95.28a4.11,4.11,0,0,1-1,.16,2.28,2.28,0,0,1-.8-.13,1.86,1.86,0,0,1-.66-.39,3.78,3.78,0,0,1-.54-.63,2.06,2.06,0,0,1-.35-.8,2,2,0,0,1,0-.87,2.4,2.4,0,0,1,.4-.86,2.75,2.75,0,0,1,.84-.72,3.44,3.44,0,0,1,1.06-.42,3.23,3.23,0,0,1,1-.07,2.18,2.18,0,0,1,.82.24,1.83,1.83,0,0,1,.59.46.33.33,0,0,1,.07.28.28.28,0,0,1-.14.22l-.85.49a.51.51,0,0,1-.29.08l-.29-.05a1.14,1.14,0,0,0-.37,0,1.56,1.56,0,0,0-.54.22,1.62,1.62,0,0,0-.51.45.42.42,0,0,0,0,.53.54.54,0,0,0,.21.19.91.91,0,0,0,.35,0,4,4,0,0,0,.58-.13l.92-.26a3.07,3.07,0,0,1,1.88-.08,2.52,2.52,0,0,1,1.25,1,1.94,1.94,0,0,1,.33.8,2.07,2.07,0,0,1,0,.89,2.49,2.49,0,0,1-.46.88,3.2,3.2,0,0,1-.92.76,3.82,3.82,0,0,1-1.13.44,3,3,0,0,1-1,0,2.35,2.35,0,0,1-.86-.27,1.8,1.8,0,0,1-.59-.49.3.3,0,0,1-.07-.27.27.27,0,0,1,.14-.22l.85-.49a.36.36,0,0,1,.31-.06l.32.08a1.16,1.16,0,0,0,.43,0,1.83,1.83,0,0,0,.62-.24,2.27,2.27,0,0,0,.32-.22,1.38,1.38,0,0,0,.27-.27.89.89,0,0,0,.15-.29A.36.36,0,0,0,193,167.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.06,158.92a.36.36,0,0,1,.27,0,.42.42,0,0,1,.25.18l.66.94a.36.36,0,0,1,.07.28.25.25,0,0,1-.14.21l-.94.55a.34.34,0,0,1-.28,0,.45.45,0,0,1-.25-.18L191,160a.42.42,0,0,1-.07-.28.28.28,0,0,1,.14-.22Zm6,8.1a.37.37,0,0,1,.07.28.27.27,0,0,1-.14.22l-.84.48a.32.32,0,0,1-.27,0,.42.42,0,0,1-.25-.18l-3.94-5.62a.41.41,0,0,1-.07-.28.28.28,0,0,1,.14-.22l.84-.48a.32.32,0,0,1,.27,0,.42.42,0,0,1,.25.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.16,166.24a2,2,0,0,0,.42-.35,1.56,1.56,0,0,0,.27-.51,1.38,1.38,0,0,0,0-.61,1.76,1.76,0,0,0-.3-.68l-.31-.45a2,2,0,0,1-.07.37,1.72,1.72,0,0,1-.18.43,2.32,2.32,0,0,1-.91.88,2.4,2.4,0,0,1-1.16.34,3.14,3.14,0,0,1-1.2-.19,4.06,4.06,0,0,1-1.13-.62,4.75,4.75,0,0,1-1-.95c-.09-.11-.19-.25-.3-.41s-.21-.31-.29-.43a4.55,4.55,0,0,1-.54-1.19,3.31,3.31,0,0,1-.14-1.19,2.34,2.34,0,0,1,.32-1.06,2.16,2.16,0,0,1,.83-.81,2.29,2.29,0,0,1,.66-.28,2.68,2.68,0,0,1,.6-.1,2.64,2.64,0,0,1,.51,0,2.58,2.58,0,0,1,.4.1l-.2-.28a.4.4,0,0,1-.07-.28.29.29,0,0,1,.14-.21l.84-.49a.38.38,0,0,1,.28,0,.49.49,0,0,1,.25.18l4,5.66a3.51,3.51,0,0,1,.8,2.63,2.87,2.87,0,0,1-1.54,1.93,3.57,3.57,0,0,1-1.15.43,3.62,3.62,0,0,1-1.13,0,3.15,3.15,0,0,1-1-.29,2,2,0,0,1-.72-.58.3.3,0,0,1-.08-.27.3.3,0,0,1,.15-.22l.74-.43a.43.43,0,0,1,.35,0l.33.1a1.44,1.44,0,0,0,.63.11A1.91,1.91,0,0,0,203.16,166.24Zm-4.6-3.92a4.48,4.48,0,0,0,.47.67,2.3,2.3,0,0,0,1.24.88,1.65,1.65,0,0,0,1.15-.18,1.3,1.3,0,0,0,.66-.88,1.78,1.78,0,0,0-.27-1.25c-.08-.12-.17-.28-.3-.47a5.2,5.2,0,0,0-.35-.44,2.09,2.09,0,0,0-1.11-.75,1.58,1.58,0,0,0-1.17.16,1.34,1.34,0,0,0-.67.88A1.94,1.94,0,0,0,198.56,162.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.77,159.11a.37.37,0,0,1,.08.28.32.32,0,0,1-.15.22l-.83.48a.34.34,0,0,1-.28,0,.45.45,0,0,1-.25-.18l-2.14-3.07a2.82,2.82,0,0,0-1.12-1,1.34,1.34,0,0,0-1.25.12,1.12,1.12,0,0,0-.62,1,2.19,2.19,0,0,0,.48,1.35l2.14,3.07a.33.33,0,0,1,.07.28.28.28,0,0,1-.14.22l-.83.48a.34.34,0,0,1-.28,0,.45.45,0,0,1-.25-.18l-3.94-5.62a.41.41,0,0,1-.07-.28.31.31,0,0,1,.14-.22l.84-.48a.33.33,0,0,1,.28,0,.49.49,0,0,1,.25.18l.19.27a2.41,2.41,0,0,1,.31-.9,2,2,0,0,1,.77-.74,3,3,0,0,1,1.28-.42,2.68,2.68,0,0,1,1.16.2,3.6,3.6,0,0,1,1,.67,6.68,6.68,0,0,1,.87,1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.57 200.4 86.24 199.87 86.64 199.64 86.31 199.11 86.72 198.87 86.39 198.34 86.8 198.11 86.47 197.58 86.88 197.35 86.55 196.82 86.95 196.59 93.72 199.33 94.05 199.86 93.64 200.09 93.97 200.62 93.57 200.85 93.9 201.38 93.49 201.62 93.82 202.15 93.41 202.38 93.74 202.91 93.33 203.14 86.57 200.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.34 305.13 159.14 304.47 158.65 304.64 158.45 303.98 157.97 304.15 157.76 303.49 157.28 303.65 157.08 303 156.59 303.17 156.39 302.51 155.9 302.68 153.25 310.28 153.45 310.94 153.94 310.77 154.14 311.43 154.63 311.26 154.83 311.92 155.32 311.75 155.52 312.41 156.01 312.24 156.21 312.9 156.7 312.74 159.34 305.13",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.25 94.36 270.99 93.72 270.52 93.94 270.26 93.3 269.79 93.51 269.53 92.87 269.06 93.09 268.8 92.45 268.32 92.66 268.06 92.02 267.59 92.23 265.65 100.05 265.91 100.69 266.38 100.48 266.64 101.12 267.11 100.9 267.37 101.54 267.84 101.33 268.1 101.97 268.57 101.75 268.83 102.39 269.31 102.18 271.25 94.36",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307,364.1c0-.2,1.16-12,1.16-12s-.84,1.21-7.68.61a37.71,37.71,0,0,1-7.62-1.77l-.45,8.59c-1.2,3.48-7.23,3-13.68,3.37-1.08.06-2.21.07-3.33.07h-.07c-3.45.4-6.53,3-2.48,5.34s10.1,2.41,15.67,2.46C295.18,370.79,306.9,370.75,307,364.1Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.36,370.88a6.72,6.72,0,0,0,.13,3.56c.33,1.24,4.18,5,10.14,6.65s12.79.69,16.14,1.06,6.58,1.7,10.49,2,7.71.12,11.05-3c.51-1.19.86-3.79.59-4C309.19,376.58,261.36,370.88,261.36,370.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.56,360.76c-2.13,2.09-7.35,1.79-12.87,2.1-5.21.29-11.27-.52-14.53,1.28s-3.83,5.86,1.76,10.3c1.62,1.28,3.43,3,5.19,3.67,5.85,2.29,12,1.1,15.92,1.38,5.09.37,8.12,2.07,12.73,1.83,6-.33,9.4-2.46,10.14-4.2s-.47-14.47-2.93-13.78c0,0-.36,4.25-10.58,1.93C291.93,364.26,291.56,361.71,291.56,360.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.11,378.11s-2-13.25,5.5-15.19l1,0s-.15-.91-3.11-1.14c-5.69-.44-9.27.27-11.66,2.71a7.35,7.35,0,0,0-1.49,6.28C262.05,373.31,265,376.26,271.11,378.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.52,370.29s-.36-5.41,3.32-7.49a2.09,2.09,0,0,1,2.21-.09s-3.55,1.16-3.68,7.59c0,0-.11.45-.93.44C277.16,370.74,276.56,370.73,276.52,370.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.47,362.55s0-.17-1-.19a1.61,1.61,0,0,0-1.05.31s-2.72,1.77-2.31,7.41a1,1,0,0,0,1.05.7.81.81,0,0,0,.95-.72S282.73,364.11,285.47,362.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.64,362.13s-.23-.31-.91-.18c-.87.15-1,.52-1,.52s-1.71,2.49-.94,7.14c0,0,.05.8,1.15.69s.8-1,.8-1S287.09,363.36,288.64,362.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.75,287.54c-.49,11.86-.09,67-.09,67s7.28,6.12,16.46,3l5.71-63.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.35,384.41c0-.2,2.16-11.51,2.16-11.51s-2.15,1.44-9,1a30.76,30.76,0,0,1-6.76-1.26L259.63,381c-1.09,3.52-7.13,3.22-13.56,3.78-1.09.1-2.21.14-3.33.17h-.07c-3.44.5-6.43,3.23-2.31,5.41s10.16,2.1,15.73,2C262.79,392.22,274.49,391.06,274.35,384.41Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,393.34a6.69,6.69,0,0,0,.23,3.55c.38,1.23,4.34,4.85,10.34,6.34s12.81.3,16.16.57,6.63,1.5,10.55,1.65,7.71-.11,11-3.34c.47-1.2.74-3.81.47-4C277,397.58,229,393.34,229,393.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.87,382.31c-2.07,2.15-7.29,2-12.8,2.48-5.2.45-11.28-.17-14.49,1.72s-3.65,6,2.07,10.24c1.66,1.23,3.52,2.87,5.3,3.51,5.92,2.12,12,.74,16,.9,5.1.22,8.19,1.83,12.79,1.44,5.94-.5,9.32-2.74,10-4.49s-.91-14.46-3.35-13.7c0,0-.23,4.27-10.52,2.26C259.34,385.79,258.89,383.25,258.87,382.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,400.26s-2.38-13.17,5-15.34l1-.07s-.18-.89-3.15-1c-5.7-.27-9.26.55-11.57,3.07a7.38,7.38,0,0,0-1.3,6.32C229.75,395.75,232.77,398.6,239,400.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.12,392.28s-.52-5.39,3.1-7.58a2.08,2.08,0,0,1,2.2-.15s-3.51,1.26-3.44,7.69c0,0-.11.45-.93.47C244.78,392.71,244.17,392.73,244.12,392.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.84,384.28s0-.17-1-.16a1.65,1.65,0,0,0-1,.34s-2.65,1.85-2.08,7.48a1,1,0,0,0,1.07.67.82.82,0,0,0,.93-.75S250.14,385.92,252.84,384.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,383.76s-.24-.29-.92-.15c-.86.18-1,.55-1,.55s-1.65,2.55-.74,7.17c0,0,.08.8,1.18.66s.77-1,.77-1S254.47,385,256,383.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.86,310.57c-1.39,12.28-2.69,47.81-3.6,65.57a24.51,24.51,0,0,0,17.72,2l12.65-63.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.44,456a1.49,1.49,0,0,1-1.48-1.49V359.33a1.48,1.48,0,0,1,3,0v95.22A1.49,1.49,0,0,1,342.44,456Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.36,421.37a1.48,1.48,0,0,1-1.38-.93l-29.2-73.91a1.48,1.48,0,0,1,2.76-1.09l29.2,73.91a1.48,1.48,0,0,1-.84,1.92A1.44,1.44,0,0,1,401.36,421.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.85,412.5a1.47,1.47,0,0,1-1.07-.47l-54.34-57.5L288.2,411.79a1.48,1.48,0,1,1-2.15-2l55.32-58.39a1.48,1.48,0,0,1,1.07-.46h0a1.51,1.51,0,0,1,1.08.46L398.93,410a1.49,1.49,0,0,1-1.08,2.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.52,421.37a1.47,1.47,0,0,1-1.37-2l29.2-73.91a1.48,1.48,0,0,1,2.75,1.09l-29.2,73.91A1.48,1.48,0,0,1,283.52,421.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.81,326.67c-1.06-6,3.8-10.64,13-16.82A216.32,216.32,0,0,1,322.3,295c7.65-3.51,15.49-3.19,25.3,1.85,13.62,7,54.62,31.86,54.62,31.86s-61.3,34.6-73.09,33-41.27-20.72-43.6-27.46S282.81,326.67,282.81,326.67Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.05,354.43c-8.8,8-18,1.11-32.55-8.33-16.46-10.69-19.69-19.43-19.69-19.43s0,6.55,1.23,9.62,3.89,6.55,15.76,14.74,20.48,12.29,28.46,13.81l6.3-.87",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,346.1c-16.46-10.69-19.69-19.43-19.69-19.43s0,6.55,1.23,9.62,3.89,6.55,15.76,14.74,20.48,12.29,28.46,13.81l6.3-.87.49-9.54C326.25,362.4,317.05,355.54,302.5,346.1Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.35,410.21l3.86,10.19a1.22,1.22,0,0,1,0,.26.6.6,0,0,1,0,.19c0,.21-.3.47-.58.64a2.56,2.56,0,0,1-2.35,0,1,1,0,0,1-.46-.48v0l0-.14-3.58-9.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.54,410.21l-3.86,10.19a.82.82,0,0,0,0,.26.6.6,0,0,0,0,.19,1.24,1.24,0,0,0,.58.64,2.56,2.56,0,0,0,2.35,0A1,1,0,0,0,285,421v0l0-.14,3.58-9.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.15,447.18v8.43a.87.87,0,0,1-.5.7,2.71,2.71,0,0,1-2.42,0,.87.87,0,0,1-.5-.7v-8.43A3.63,3.63,0,0,1,344.15,447.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,303s-49.17-14.84-57.72-17.18-24.95-6.28-29.74-4.13-7.22,4.63-7.66,11.55c-.09,1.29,0,7.62,0,7.62S312.76,311,332.24,311,383,303,383,303Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.15,296.82c3.09,10.53,4.05,20.83-3.32,28.42-5.36,5.53-27.58,25.23-47.07,19.26C311,337.83,285,318.93,285,318.93s-16.81.51-16.89-4.42c0-1.21-5.31-2.71-5.25-4,.68-14.48,10.43-20.51,25-17.88,15.24,2.77,49.33,12.48,49.33,12.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.82,340.65c3.67-13.38,8.05-30.36,8.05-30.36l-20.09,6.34c-4.15,13.13-6.25,20.26-16.62,18.57S285,318.93,285,318.93s26,18.9,47.76,25.57C341.49,347.18,350.76,344.69,358.82,340.65Z",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.73,215.94c9.64-2.62,17.5,1.13,19.37,10.05,1.48,7.06.18,20.25-1.54,32,0,0-5.63,2.12-17.22-2.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.99 211.13 354.16 231.14 372.19 230.23 370.09 206.82 350.99 211.13",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.34,223.2c-5.95-9.48-19.41-7-19.41-7l.2,2.25c-.83,3.37-9.71,4.55-18.54,2.47l-.18-.8s-10.55,3.25-14.46,5.5c-5.79,3.34-8.27,11.19-4.54,33.86,2.77,16.82,1.15,40.39-3.73,51.19,9,11.46,30.93,9.9,40.06,8.12,19-3.71,22-13.93,22-13.93s4-34.71,3.8-49.72C395.34,242.4,394.09,229.19,390.34,223.2Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.34,223.2c-5.95-9.48-19.41-7-19.41-7l.2,2.25c-.83,3.37-9.71,4.55-18.54,2.47l-.18-.8s-10.55,3.25-14.46,5.5c-5.79,3.34-8.27,11.19-4.54,33.86,2.77,16.82,1.15,40.39-3.73,51.19,9,11.46,30.93,9.9,40.06,8.12,19-3.71,22-13.93,22-13.93s4-34.71,3.8-49.72C395.34,242.4,394.09,229.19,390.34,223.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.5,275.14c-4.82,14.32-6,19.91-13.52,44a69.47,69.47,0,0,0,23.76-.37c19-3.71,22-13.93,22-13.93s4-34.71,3.8-49.72c0-2.76-.13-5.54-.29-8.26C377.69,250.7,363.92,262,359.5,275.14Z",
    style: {
      fill: "#2F55D4",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.64,186.58s-4.72,7.17-4.19,7.88,4,1.34,4,1.34Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.77,166.73c-9.56,2-12.33,6.22-13.23,21.42-.94,15.89.68,20.88,2.77,23,1.41,1.44,9.23,1.7,13.18.62,4.95-1.37,16.11-5.33,21.35-13.32,6.15-9.4,7.77-22.14,1.18-27.36C366.75,163.75,354.67,165.91,350.77,166.73Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.31,211.17c1.16,1.19,6.73,1.58,10.85,1.05l-.19-2.07s-4.53,1-6.84,1.26a8.73,8.73,0,0,1-3.85-.27Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.42,173.29l0,0c2.72,1.79,6,2.48,9.24,2.91-.19,2.58.68,5.11,1.53,7.55.6,1.68,2.72,7,4.83,4,1.52-2.16,2.91-4.12,5.93-3.67,5,.75,5.65,7.1,2.51,11s-6.06,2.38-6.06,2.38.15,8.39,3.87,13.14c0,0,4.23,1.37,12-.28,4.79-1,11.55-7,14.4-13.33,6-13.4,6.43-25.45-2.12-29.06-.92-6.17-5.78-8.94-11.32-10.21-7.68-1.77-15.5,3.2-23,.21-1.57-.63-3-1.54-4.62-2.08a3.12,3.12,0,0,0-2.75.07,3.34,3.34,0,0,0-1.13,2.13,6,6,0,0,0,.39,4.4,12.89,12.89,0,0,0-3.49-1.2,4.36,4.36,0,0,0-3.49.87,4.51,4.51,0,0,0-1.34,3.09C330.65,168.42,332.71,171.5,335.42,173.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.93,217.25l-7.73,3.82a.27.27,0,0,0,.06.5l8.52,1.68Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.22,221.55l0,0,8.52,1.68-.45-3.18-1.06.14-6.92,1.07Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.26,221.57a.27.27,0,0,1-.06-.5l1.51-.74h0a1.44,1.44,0,0,0,.28,1.48l.1.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.85,218.46l-.79.11-1,.13-34.32,4.55a3.86,3.86,0,0,1-1.52-2.38,4,4,0,0,1,.67-3.62l34.31-4.54,1.82-.24C260.89,212.69,261.67,218.67,262.85,218.46Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.85,218.46l-.8.11-.95.13-34.32,4.55a4.11,4.11,0,0,1-1.63-3l36.27-5c0-.11,0-.15.1-.12C261.65,216.76,262.19,218.58,262.85,218.46Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,218.87l-1.76.23c-.51.09-1-1-1.26-2.21-.38-1.65-.18-3.68.49-3.79l1.31-.17.46-.06c-.67.12-.87,2.15-.5,3.8.27,1.19.72,2.21,1.21,2.21h.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.39,218.93c-1.18.19-1.94-5.81-.76-6l1.77-.24c-1.19.2-.42,6.2.76,6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.85,218.46l-1.75.24c-1.16.2-2-5.58-.86-6l.06,0,1.76-.22C260.89,212.69,261.67,218.67,262.85,218.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.06,221.36a.26.26,0,0,0,.16.19A.26.26,0,0,1,218.06,221.36Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.49,218l-3.64.45c-.51.09-1-.94-1.27-2.18-.38-1.65-.19-3.69.48-3.81h0l3.66-.46c1.48-.19,2.24,2.76,1.86,4.64A1.54,1.54,0,0,1,266.49,218Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,216.65a4.68,4.68,0,0,1,.16-4.15A1,1,0,0,1,266,212c1.32.13,2,2.86,1.62,4.64a1.56,1.56,0,0,1-1.07,1.35C266,218.07,265.36,217.59,265,216.65Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.37,219.46q.4.48.84.93A8.43,8.43,0,0,1,258.3,225c.84,4.36-.26,4,4.15,6.41s24.42,14.07,24.42,14.07c4.42-2,21-10.26,27.25-13.42,11.55-5.83,16.94-9.59,28.29-8.35,3.16,6.59-.49,19.52-10,26.18-8.4,5.9-30.46,11.47-39.73,14.2-1,.32-1.89.58-2.7.79l-.16,0c-5.54,1.41-7.11.19-11.49-3-3.38-2.44-6.72-4.93-10.05-7.43q-3.56-2.67-7.09-5.37c-2.25-1.73-4.64-3.24-6.84-5a114.4,114.4,0,0,0-10.78-7.54c-5.53-3.41-11.27-7.39-12-14.41a29.31,29.31,0,0,1,.11-5.54l.48-5.72a1.78,1.78,0,0,1,.27-.94c.46-.57,1.38-.31,2,0,4.68,2.56,8,7.17,12.62,9.79a3.26,3.26,0,0,0,2.65.42Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,223.16c-5.53-.76-9.33-1.95-18.56,2.56s-25.4,13.09-25.4,13.09-1.88,14.43,7.84,23.26c0,0,23.61-8.53,29.38-12.2S347.46,233.54,343.55,223.16Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.56,364c5-.25,8.94-3.93,20.85-8.9,22-9.16,38.5-16.49,44.78-28s10.74-44.78,9.17-59.18a18.94,18.94,0,0,0-1.08-4.77l1.54-.23-4-3.41h0c-4.11-3.36-10.8-.37-15.84,2.38-14.4,7.83-25.67,15.45-34.57,42.94-6.7,20.69-11.11,39.55-20.36,49.64",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.28,263.1l1.55-.23-4-3.41h0c-4.11-3.36-10.8-.37-15.84,2.38-14.4,7.83-25.67,15.45-34.57,42.94-6.7,20.69-11.11,39.55-20.36,49.64l-.49,9.54c5-.25,8.94-3.93,20.85-8.9,22-9.16,38.5-16.49,44.78-28s10.74-44.78,9.17-59.18A18.94,18.94,0,0,0,408.28,263.1Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.15,265.39c-14.4,7.84-25.66,15.45-34.57,42.95s-13.77,51.79-31.32,56.5c0,0,7.94,3.15,32.25-7.13,7.73-3.27,17.12-9.24,23.29-12.7,12.08-6.78,19.41-12.34,20.56-14.42,6.39-11.46,10.74-44.78,9.17-59.18S401.36,261.46,394.15,265.39Z",
    style: {
      fill: "#2F55D4"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--thought-bubble--inject-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--User--inject-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bubble--inject-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Facebook--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.49,159.41a1.33,1.33,0,0,0-1.34.13,4.19,4.19,0,0,0-1.89,3.28,1.32,1.32,0,0,0,.56,1.22l2.72,1.62a1.33,1.33,0,0,0,1.34-.13,4.16,4.16,0,0,0,1.89-3.27,1.34,1.34,0,0,0-.55-1.23",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.88,161.16a4.2,4.2,0,0,0-1.89,3.28c0,1.21.85,1.7,1.89,1.09a4.16,4.16,0,0,0,1.89-3.27C405.77,161.05,404.92,160.56,403.88,161.16Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.49,159.41l2.73,1.62a1.33,1.33,0,0,0-1.34.13,4.22,4.22,0,0,0-1.62,2l-2.72-1.62a4.1,4.1,0,0,1,1.61-2A1.33,1.33,0,0,1,402.49,159.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.52,165.65l-2.7-1.61a1.33,1.33,0,0,1-.56-1.22l2.73,1.62A1.34,1.34,0,0,0,402.52,165.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.54,161.52l2.72,1.62a3.65,3.65,0,0,0-.27,1.3h0l-2.73-1.62A3.42,3.42,0,0,1,399.54,161.52Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--facebook--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.9,167.44a1.12,1.12,0,0,0-1.14.11,3.57,3.57,0,0,0-1.62,2.81,1.11,1.11,0,0,0,.48,1l2.32,1.39a1.14,1.14,0,0,0,1.15-.11,3.59,3.59,0,0,0,1.62-2.8,1.13,1.13,0,0,0-.48-1",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.09,168.94a3.6,3.6,0,0,0-1.62,2.81c0,1,.73,1.45,1.62.93a3.59,3.59,0,0,0,1.62-2.8C396.71,168.85,396,168.43,395.09,168.94Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.9,167.44l2.33,1.39a1.12,1.12,0,0,0-1.14.11,3.5,3.5,0,0,0-1.38,1.7l-2.34-1.39a3.58,3.58,0,0,1,1.39-1.7A1.12,1.12,0,0,1,393.9,167.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.92,172.78l-2.3-1.38a1.11,1.11,0,0,1-.48-1l2.33,1.39A1.14,1.14,0,0,0,393.92,172.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.37,169.25l2.34,1.39a3,3,0,0,0-.24,1.11h0l-2.33-1.39A3.19,3.19,0,0,1,391.37,169.25Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--facebook--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.52,147.31a2.11,2.11,0,0,0-2.12.21,6.6,6.6,0,0,0-3,5.18,2.1,2.1,0,0,0,.88,1.93l3,1.78a2.09,2.09,0,0,0,2.11-.21,6.6,6.6,0,0,0,3-5.18,2.09,2.09,0,0,0-.87-1.93",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.4,149.3a6.6,6.6,0,0,0-3,5.18c0,1.9,1.34,2.67,3,1.72a6.6,6.6,0,0,0,3-5.18C414.39,149.12,413.05,148.34,411.4,149.3Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.52,147.31l3,1.78a2.11,2.11,0,0,0-2.12.21,6.5,6.5,0,0,0-2.55,3.13l-3-1.78a6.45,6.45,0,0,1,2.55-3.13A2.11,2.11,0,0,1,410.52,147.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.25,156.39l-3-1.76a2.1,2.1,0,0,1-.88-1.93l3,1.78A2.17,2.17,0,0,0,409.25,156.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.85,150.65l3,1.78a5.48,5.48,0,0,0-.44,2h0l-3-1.78A5.48,5.48,0,0,1,405.85,150.65Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--facebook--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.85,130.71a2.89,2.89,0,0,0-2.9.29,9.07,9.07,0,0,0-4.11,7.11,2.91,2.91,0,0,0,1.21,2.67l3,1.77a2.87,2.87,0,0,0,2.9-.29,9.07,9.07,0,0,0,4.11-7.11,2.88,2.88,0,0,0-1.21-2.66",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,132.78a9.07,9.07,0,0,0-4.11,7.11c0,2.62,1.84,3.68,4.11,2.37a9.07,9.07,0,0,0,4.11-7.11C420.05,132.53,418.22,131.47,416,132.78Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.85,130.71l3,1.78a2.87,2.87,0,0,0-2.9.29,9,9,0,0,0-3.51,4.3l-3-1.78A8.93,8.93,0,0,1,413,131,2.89,2.89,0,0,1,415.85,130.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,142.52l-2.94-1.74a2.91,2.91,0,0,1-1.21-2.67l3,1.78A2.93,2.93,0,0,0,413,142.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.44,135.3l3,1.78a7.64,7.64,0,0,0-.6,2.81h0l-3-1.78A7.64,7.64,0,0,1,409.44,135.3Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M426.77,45.54c-6.43-4-15.45-3.61-25.45,2.16C381.82,59,366,86.35,366,108.88c0,11.07,3.83,18.89,10,22.66.76.46,3.47,2,4.06,2.34,6.4,3.82,15.31,3.34,25.16-2.35,19.5-11.26,35.33-38.65,35.31-61.17,0-11.26-4-19.17-10.37-22.85C429.54,47.13,427.24,45.84,426.77,45.54Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.77,45.54c-6.43-4-15.45-3.61-25.45,2.16C381.82,59,366,86.35,366,108.88c0,11.07,3.83,18.89,10,22.66.76.46,3.47,2,4.06,2.34,6.4,3.82,15.31,3.34,25.16-2.35,19.5-11.26,35.33-38.65,35.31-61.17,0-11.26-4-19.17-10.37-22.85C429.54,47.13,427.24,45.84,426.77,45.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.23,108.46l-53.72-31c-5.3,10.18-8.5,21.3-8.5,31.43,0,11.07,3.83,18.89,10,22.66.76.46,3.47,2,4.06,2.34,6.4,3.82,15.31,3.34,25.16-2.35C414,126.47,422.05,118.14,428.23,108.46Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.23,108.46l-53.72-31c-5.3,10.18-8.5,21.3-8.5,31.43,0,11.07,3.83,18.89,10,22.66.76.46,3.47,2,4.06,2.34,6.4,3.82,15.31,3.34,25.16-2.35C414,126.47,422.05,118.14,428.23,108.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.74,100.21a55,55,0,0,0-.73,8.67c0,11.07,3.83,18.89,10,22.66.76.46,3.47,2,4.06,2.34,6.4,3.82,15.31,3.34,25.16-2.35a54.07,54.07,0,0,0,7.13-5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.25,50c-19.5,11.27-35.31,38.65-35.31,61.17s15.82,31.66,35.32,20.39,35.33-38.65,35.31-61.17S424.74,38.71,405.25,50Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,103.58c-6.58-.27-24.07-2.5-24.07-2.5h0A34.83,34.83,0,0,1,380.19,69.4l.38-5.44a22.13,22.13,0,0,1,18.67-20.47,20.26,20.26,0,0,1,23.27,21.45c-.19,2.67.11,5.12,2,7.2A20.39,20.39,0,0,0,428,74.92a17.3,17.3,0,0,1,4.63,4.39,7.8,7.8,0,0,1,1.28,6.1,7.32,7.32,0,0,1-2.14,3.47.9.9,0,0,0-.37.55.85.85,0,0,0,.16.45c1.56,2.86,2,6.53.35,9.31a8.88,8.88,0,0,1-4.81,3.64,17.76,17.76,0,0,1-6.07.78Q420.51,103.61,420,103.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.16,103.74a14,14,0,0,1-5.29,9.21,12.12,12.12,0,0,1-3.16,1.79s0,0,0,0l-5,15.4c-3.66-4.31-5.78-10.77-5.78-19a55.34,55.34,0,0,1,.93-9.88h0c2.55-6.32,5.76-9,12.92-9.73a0,0,0,0,0,0,0C384.17,91.77,390.37,96,389.16,103.74Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.87,99.28c2.66,6.35,6.36,16.83,8.57,23.21L444.09,110h9s-10.73,23-17.19,28.31c-4.31,3.52-7,.92-8.07-1.26h0c0-.07-1.83-3.23-4.19-8-3-6.17-6.31-12.94-6.31-12.94l-7.07-26.31C415.82,89.3,421.5,91.21,424.87,99.28Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.44,122.49a39,39,0,0,0-3.28,4.47s1.28-4.28,2.84-5.72Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.74,93.28h0l-.84-.89h0a1.05,1.05,0,0,0-.94-.2L443.64,94a3.7,3.7,0,0,0-2.46,1.88L431.91,116a.92.92,0,0,0,0,1.07h0l.87.91h0a1.06,1.06,0,0,0,1,.21l10.31-1.75a3.73,3.73,0,0,0,2.47-1.89l9.27-20.16A.92.92,0,0,0,455.74,93.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.76,116.9,442,96.74a3.71,3.71,0,0,1,2.46-1.89l10.32-1.75c1-.17,1.4.42,1,1.3l-9.27,20.16a3.73,3.73,0,0,1-2.47,1.89l-10.31,1.75C432.8,118.36,432.35,117.78,432.76,116.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.34,95.32A3.61,3.61,0,0,0,442,96.74l-9.27,20.15a1,1,0,0,0,0,1.06l-.82-.86h0a.94.94,0,0,1,0-1.08l9.27-20.16a3.44,3.44,0,0,1,1.22-1.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.85,113.22c4.27-4.9,4.15-11,2.19-12.8l-1.3,2.83s-6.53,1.45-9.67,1.21-5.71-1-6.57-.38c-1.82,1.29-2.34,6.76,2.88,8.75C442.82,114.52,450.85,113.22,450.85,113.22Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77,116.73l-.24,5.18a58.73,58.73,0,0,1-12.27,9.63,34.68,34.68,0,0,1-13.06,4.66,19.93,19.93,0,0,1-9.64-1.1l.73-2.28-2.6-18.06s0,0,0,0a7.5,7.5,0,0,0,1-1.23c.14-.21.29-.43.45-.69a9,9,0,0,0,.52-.9c.11-.22.22-.44.33-.68s.23-.48.34-.75.13-.29.2-.43l.35-.94.09-.28h0a27,27,0,0,0,1.16-5.09c1-7.17-.81-11.47-1.38-12.21a0,0,0,0,1,0,0c.3-.09,6.9-.46,6.9-.46l13.24-1.55,6.35.24a26.4,26.4,0,0,1,10.66,12.74C424.3,110.81,417.77,116.73,417.77,116.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.2,136.2a19.93,19.93,0,0,1-9.64-1.1l.73-2.28-2.6-18.06s0,0,0,0a7.5,7.5,0,0,0,1-1.23c.14-.21.29-.43.45-.69a9,9,0,0,0,.52-.9c.11-.22.22-.44.33-.68s.23-.48.34-.75.13-.29.2-.43l.35-.94.09-.28c-.06,1-.13,2.48-.15,4.11a46.5,46.5,0,0,0,.25,5.54c.58,4.73,5.65,15,7.63,16.67A1.06,1.06,0,0,1,392.2,136.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.8,53.75c1.44,1.33,3.45,4.89,3.7,17,.21,10.27-3,13-4.64,13.76s-4.79.5-7.94.11v6.13s7.85,7.75,2.53,8.79a14.65,14.65,0,0,1-9.87-1.83,26.26,26.26,0,0,1-6.71-5.22V77.66s-1.77,1.87-5-.72c-2.68-2.14-3.72-5.91-1.79-8A4.5,4.5,0,0,1,392.28,70s5,0,11.49-4S414.54,57.75,414.8,53.75Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.2,68.87a1.29,1.29,0,1,1-2.57.24,1.29,1.29,0,1,1,2.57-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,77.1l3.46.94a1.76,1.76,0,0,1-2.17,1.32A1.87,1.87,0,0,1,407,77.1Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.92,64.46l-3-1.06a1.52,1.52,0,0,1,2-1A1.67,1.67,0,0,1,416.92,64.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.74,68.42a1.29,1.29,0,1,1-1.41-1.22A1.32,1.32,0,0,1,416.74,68.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.88 66.99 411.18 75.4 415.21 73.96 410.88 66.99",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.92,84.62c-3.32-.29-10.28-1.94-11.46-4.58A7,7,0,0,0,397,83.36c2.11,1.65,8.93,3.32,8.93,3.32Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.27,72.82a2.59,2.59,0,1,0,0-5.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Music--inject-37",
    d: "M449.59,59.36l3.29,16.37a3.81,3.81,0,0,0-1.21,0,3.15,3.15,0,1,0,4.14,2.35l-2.64-13.25,12.2-2.42h0l2.07,10.38a4.19,4.19,0,0,0-1.22,0,3.15,3.15,0,1,0,4.14,2.36h0L466.51,56Z",
    style: {
      fill: "#2F55D4"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "95.58 85.38 144.49 70.17 106.87 96.24 95.58 85.38",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.49 70.17 91.82 78.86 80.54 68 144.49 70.17",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.82 78.86 91.82 91.89 95.58 85.38 144.49 70.17 91.82 78.86",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.82 78.86 91.82 91.89 95.58 85.38 144.49 70.17 91.82 78.86",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.82 91.89 99.34 89 95.58 85.38 91.82 91.89",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.58 85.38 99.34 89 98.14 89.46 95.58 85.38",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.24,90.33a.83.83,0,0,1-.41-1.56c1-.56,2-1.08,3-1.56a.83.83,0,1,1,.72,1.5c-1,.46-1.93,1-2.89,1.51A.87.87,0,0,1,83.24,90.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.81,163.85a.8.8,0,0,1-.51-.17,37.31,37.31,0,0,1-5.07-4.74.83.83,0,1,1,1.24-1.1,36.5,36.5,0,0,0,4.85,4.53.83.83,0,0,1,.15,1.16A.84.84,0,0,1,73.81,163.85Zm-8.38-9.14a.83.83,0,0,1-.7-.38,40.59,40.59,0,0,1-3.23-6.13.83.83,0,0,1,1.53-.65,37.36,37.36,0,0,0,3.1,5.88.83.83,0,0,1-.7,1.28Zm-5-11.36a.82.82,0,0,1-.8-.61A46,46,0,0,1,58.31,136a.83.83,0,0,1,1.64-.2,45.15,45.15,0,0,0,1.27,6.55.83.83,0,0,1-.58,1ZM58.8,130.2H58a50.68,50.68,0,0,1,.46-6.89.83.83,0,1,1,1.64.22,50.49,50.49,0,0,0-.44,6.61Zm1.57-11.5-.22,0a.83.83,0,0,1-.58-1,43.7,43.7,0,0,1,2.34-6.52.83.83,0,0,1,1.52.69,41.14,41.14,0,0,0-2.26,6.27A.82.82,0,0,1,60.37,118.7Zm5-11.39a.82.82,0,0,1-.43-.12.84.84,0,0,1-.27-1.15,46,46,0,0,1,4.07-5.59.84.84,0,0,1,1.17-.1.83.83,0,0,1,.09,1.17,44.91,44.91,0,0,0-3.92,5.4A.84.84,0,0,1,65.33,107.31Zm7.9-9.6a.87.87,0,0,1-.61-.26.85.85,0,0,1,0-1.18A52.69,52.69,0,0,1,78,91.88a.83.83,0,0,1,1.16.19A.84.84,0,0,1,79,93.23a51.8,51.8,0,0,0-5.16,4.25A.8.8,0,0,1,73.23,97.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.54,168.47a.83.83,0,0,1-.34-.07c-1-.47-2.06-1-3-1.52a.83.83,0,1,1,.8-1.45c.94.52,1.92,1,2.91,1.46A.82.82,0,0,1,82.3,168,.83.83,0,0,1,81.54,168.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiondesignAmico);
export default __webpack_public_path__ + "static/media/interactiondesign-amico.0e75d69669bbd635f59e4b1a7b87598f.svg";
export { ForwardRef as ReactComponent };